<template>
    <div class="page product-list-page">
        <a-modal
            v-model:open="open"
            :title="productForm.id ? '編輯商品' : '新增商品'"
            ok-text="確定"
            cancel-text="取消"
            :width="900"
            class="product-modal"
            @ok="handleEdit"
        >
            <a-form
                ref="form"
                :model="productForm"
                :rules="formRules"
                layout="vertical"
                class="product-form"
            >
                <a-tabs
                    v-model:activeKey="productFormActiveTab"
                    type="card"
                    class="product-form-tabs"
                >
                    <a-tab-pane key="basic">
                        <template #tab>
                            <span class="tab-label-wrap">
                                基本
                                <a-badge
                                    v-if="tabErrorKeys.includes('basic')"
                                    status="error"
                                    class="tab-error-badge"
                                />
                            </span>
                        </template>
                        <div class="tab-pane-content">
                            <!-- 基本資訊區塊 -->
                            <div class="form-section">
                                <div class="form-section-title">基本資訊</div>
                                <div class="form-row">
                                    <a-form-item
                                        label="商品名稱"
                                        name="name"
                                        class="form-item-half"
                                    >
                                        <a-input
                                            v-model:value="productForm.name"
                                            placeholder="請輸入商品名稱"
                                            size="large"
                                        />
                                    </a-form-item>

                                    <a-form-item
                                        label="商品分類"
                                        name="category_id"
                                        class="form-item-half"
                                    >
                                        <a-tree-select
                                            ref="category_ide_select"
                                            v-model:value="
                                                productForm.category_id
                                            "
                                            :tree-data="categoryTreeDataForForm"
                                            :field-names="{
                                                label: 'label',
                                                value: 'value',
                                                children: 'children'
                                            }"
                                            placeholder="請選擇分類"
                                            allow-clear
                                            tree-default-expand-all
                                            show-search
                                            size="large"
                                        />
                                    </a-form-item>
                                </div>

                                <a-form-item
                                    v-if="showVendorField"
                                    label="寄賣廠商"
                                    name="vendor_id"
                                    class="form-item-half"
                                >
                                    <a-select
                                        v-model:value="productForm.vendor_id"
                                        :options="vendorOptions"
                                        placeholder="未選則為自營"
                                        allow-clear
                                        size="large"
                                    />
                                </a-form-item>

                                <a-form-item
                                    label="商品副標題"
                                    name="subtitle"
                                    class="form-item-full"
                                >
                                    <a-input
                                        v-model:value="productForm.subtitle"
                                        placeholder="請輸入商品副標題"
                                        size="large"
                                    />
                                </a-form-item>

                                <a-form-item
                                    label="商品描述"
                                    name="description"
                                    class="form-item-full"
                                >
                                    <a-textarea
                                        v-model:value="productForm.description"
                                        placeholder="請輸入商品描述"
                                        :rows="3"
                                        size="large"
                                    />
                                </a-form-item>
                            </div>

                            <!-- 商品設定區塊 -->
                            <div class="form-section">
                                <div class="form-section-title">商品設定</div>
                                <div class="form-row">
                                    <a-form-item
                                        label="商品類型"
                                        name="type"
                                        class="form-item-half"
                                    >
                                        <a-radio-group
                                            v-model:value="productForm.type"
                                            name="radioGroup"
                                            size="small"
                                            class="form-radio-group"
                                        >
                                            <a-radio
                                                v-for="t in typeOpt.filter(
                                                    (t) => t.value !== null
                                                )"
                                                :value="t.value"
                                                :key="t.label"
                                            >
                                                {{ t.label }}
                                            </a-radio>
                                        </a-radio-group>
                                    </a-form-item>

                                    <a-form-item
                                        label="商品狀態"
                                        name="status"
                                        class="form-item-half"
                                    >
                                        <a-radio-group
                                            v-model:value="productForm.status"
                                            name="radioGroup"
                                            size="small"
                                            class="form-radio-group"
                                        >
                                            <a-radio
                                                v-for="t in statusOpt.filter(
                                                    (s) => s.value !== null
                                                )"
                                                :value="t.value"
                                                :key="t.label"
                                            >
                                                {{ t.label }}
                                            </a-radio>
                                        </a-radio-group>
                                    </a-form-item>
                                </div>

                                <a-form-item
                                    label="是否需要寄送"
                                    name="requires_shipping"
                                    class="form-item-full"
                                >
                                    <a-radio-group
                                        v-model:value="
                                            productForm.requires_shipping
                                        "
                                        name="radioGroup"
                                        size="small"
                                        class="form-radio-group"
                                    >
                                        <a-radio :value="1">是</a-radio>
                                        <a-radio :value="0">否</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                            </div>

                            <!-- 價格與庫存區塊 -->
                            <div class="form-section">
                                <div class="form-section-title">價格與庫存</div>
                                <div class="form-row">
                                    <a-form-item
                                        label="商品價格"
                                        name="price"
                                        class="form-item-third"
                                    >
                                        <a-input-number
                                            v-model:value="productForm.price"
                                            placeholder="請輸入商品價格"
                                            :min="0"
                                            :precision="0"
                                            style="width: 100%"
                                            size="large"
                                        />
                                    </a-form-item>

                                    <a-form-item
                                        label="庫存數量"
                                        name="stock_qty"
                                        class="form-item-third"
                                    >
                                        <a-input-number
                                            v-model:value="
                                                productForm.stock_qty
                                            "
                                            placeholder="留空=無限，0=無庫存"
                                            :min="0"
                                            :precision="0"
                                            style="width: 100%"
                                            size="large"
                                        />
                                    </a-form-item>

                                    <a-form-item
                                        label="最大購買數量"
                                        name="per_user_max_qty"
                                        class="form-item-third"
                                    >
                                        <a-input-number
                                            v-model:value="
                                                productForm.per_user_max_qty
                                            "
                                            placeholder="0 或留空表示無限制"
                                            :min="0"
                                            :precision="0"
                                            style="width: 100%"
                                            size="large"
                                        />
                                    </a-form-item>
                                </div>
                            </div>

                            <!-- 時間設定區塊 -->
                            <div class="form-section">
                                <div class="form-section-title">上架時間</div>
                                <div class="form-row">
                                    <a-form-item
                                        label="上架時間"
                                        name="publish_at"
                                        class="form-item-half"
                                    >
                                        <a-date-picker
                                            v-model:value="
                                                productForm.publish_at
                                            "
                                            placeholder="請選擇上架時間"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            style="width: 100%"
                                            size="large"
                                            @change="handlePublishAtChange"
                                        />
                                    </a-form-item>

                                    <a-form-item
                                        label="下架時間"
                                        name="unpublish_at"
                                        class="form-item-half"
                                    >
                                        <a-date-picker
                                            v-model:value="
                                                productForm.unpublish_at
                                            "
                                            placeholder="請選擇下架時間"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            style="width: 100%"
                                            size="large"
                                            @change="handleUnpublishAtChange"
                                        />
                                    </a-form-item>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>

                    <!-- 背包物品 tab -->
                    <a-tab-pane key="inventory">
                        <template #tab>
                            <span class="tab-label-wrap">
                                背包物品
                                <a-badge
                                    v-if="tabErrorKeys.includes('inventory')"
                                    status="error"
                                    class="tab-error-badge"
                                />
                            </span>
                        </template>
                        <div class="tab-pane-content">
                            <div class="form-section">
                                <div class="form-section-title">
                                    發放物品設定
                                </div>
                                <p class="form-section-hint">
                                    購買此商品後，系統將自動發放以下物品至會員背包。
                                </p>

                                <!-- 已加入的物品列表 -->
                                <div
                                    v-if="productForm.items.length > 0"
                                    class="product-items-list"
                                >
                                    <div
                                        v-for="(item, idx) in productForm.items"
                                        :key="item.inventory_item_id"
                                        class="product-item-row"
                                    >
                                        <div class="product-item-thumb-wrap">
                                            <img
                                                v-if="
                                                    canShowInventoryThumb(
                                                        item.cover_image_url,
                                                        item.inventory_item_id
                                                    )
                                                "
                                                :src="
                                                    resolveUploadAssetUrl(
                                                        item.cover_image_url
                                                    )
                                                "
                                                alt=""
                                                class="product-item-thumb"
                                                @error="
                                                    onInventoryThumbError(
                                                        item.inventory_item_id
                                                    )
                                                "
                                            />
                                            <div
                                                v-else
                                                class="product-item-thumb-placeholder"
                                            >
                                                <PictureOutlined />
                                            </div>
                                        </div>
                                        <div class="product-item-body">
                                            <div class="product-item-meta">
                                                <a-tag
                                                    :color="
                                                        getItemTypeColor(
                                                            item.type
                                                        )
                                                    "
                                                    size="small"
                                                    class="item-type-tag"
                                                >
                                                    {{
                                                        getItemTypeLabel(
                                                            item.type
                                                        )
                                                    }}
                                                </a-tag>
                                                <span class="product-item-name">
                                                    {{ item.name }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="product-item-actions">
                                            <div class="product-item-qty">
                                                <span class="qty-label">
                                                    數量
                                                </span>
                                                <a-input-number
                                                    v-model:value="item.qty"
                                                    :min="1"
                                                    :precision="0"
                                                    size="small"
                                                    class="product-item-qty-input"
                                                />
                                            </div>
                                            <a-button
                                                size="small"
                                                type="text"
                                                danger
                                                @click="removeProductItem(idx)"
                                            >
                                                <DeleteOutlined />
                                            </a-button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="product-items-empty">
                                    尚未設定發放物品
                                </div>

                                <!-- 新增物品 -->
                                <div class="product-item-add-row">
                                    <a-select
                                        v-model:value="newItemId"
                                        show-search
                                        :filter-option="false"
                                        :options="inventoryItemOptions"
                                        :loading="inventoryItemLoading"
                                        placeholder="搜尋並選擇物品"
                                        style="flex: 1"
                                        size="small"
                                        @search="handleItemSearch"
                                        @focus="handleItemSearchInit"
                                    />
                                    <a-input-number
                                        v-model:value="newItemQty"
                                        :min="1"
                                        :precision="0"
                                        size="small"
                                        style="width: 80px"
                                        placeholder="數量"
                                    />
                                    <a-button
                                        size="small"
                                        class="action-btn-view"
                                        @click="addProductItem"
                                    >
                                        加入
                                    </a-button>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>

                    <a-tab-pane key="rules">
                        <template #tab>
                            <span class="tab-label-wrap">
                                規則
                                <a-badge
                                    v-if="tabErrorKeys.includes('rules')"
                                    status="error"
                                    class="tab-error-badge"
                                />
                            </span>
                        </template>
                        <div class="tab-pane-content">
                            <!-- 可見性規則區塊（緊湊表格式） -->
                            <div class="form-section">
                                <div class="form-section-title">可見性規則</div>
                                <div class="rules-compact">
                                    <div
                                        v-if="
                                            productForm.visibility_rules
                                                .length === 0
                                        "
                                        class="compact-empty"
                                    >
                                        <a-button
                                            type="dashed"
                                            block
                                            @click="addVisibilityRule"
                                            size="small"
                                        >
                                            <PlusOutlined />
                                            新增可見性規則
                                        </a-button>
                                    </div>
                                    <template v-else>
                                        <div class="compact-table-wrap">
                                            <div class="rules-table-header">
                                                <span class="col-type">
                                                    受眾類型
                                                </span>
                                                <span class="col-ref">
                                                    受眾
                                                </span>
                                                <span class="col-action">
                                                    操作
                                                </span>
                                            </div>
                                            <div
                                                v-for="(
                                                    rule, index
                                                ) in productForm.visibility_rules"
                                                :key="index"
                                                class="rules-table-row"
                                            >
                                                <div class="col-type">
                                                    <a-select
                                                        v-model:value="
                                                            rule.audience_type
                                                        "
                                                        :options="
                                                            getRuleTypeOptions()
                                                        "
                                                        placeholder="選擇"
                                                        size="small"
                                                        class="input-full"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'visibility',
                                                                    index
                                                                )
                                                        "
                                                    />
                                                </div>
                                                <div class="col-ref">
                                                    <a-select
                                                        v-if="
                                                            getRuleTypeDataOptions(
                                                                rule.audience_type
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        option-filter-prop="label"
                                                        :options="
                                                            getRuleTypeDataOptions(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        :placeholder="
                                                            getRuleTypePlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        size="small"
                                                        class="input-full"
                                                        allow-clear
                                                    />
                                                    <a-select
                                                        v-else-if="
                                                            rule.audience_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員（可多選）"
                                                        size="small"
                                                        class="input-full"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'visibility',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    />
                                                </div>
                                                <div class="col-action">
                                                    <a-button
                                                        type="text"
                                                        danger
                                                        size="small"
                                                        @click="
                                                            removeVisibilityRule(
                                                                index
                                                            )
                                                        "
                                                    >
                                                        <DeleteOutlined />
                                                    </a-button>
                                                </div>
                                            </div>
                                        </div>
                                        <a-button
                                            type="link"
                                            size="small"
                                            class="add-compact-link"
                                            @click="addVisibilityRule"
                                        >
                                            <PlusOutlined />
                                            新增可見性規則
                                        </a-button>
                                    </template>
                                </div>
                            </div>

                            <!-- 可購買性規則區塊（緊湊表格式） -->
                            <div class="form-section">
                                <div class="form-section-title">
                                    可購買性規則
                                </div>
                                <div class="rules-compact">
                                    <div
                                        v-if="
                                            productForm.purchasable_rules
                                                .length === 0
                                        "
                                        class="compact-empty"
                                    >
                                        <a-button
                                            type="dashed"
                                            block
                                            @click="addPurchasableRule"
                                            size="small"
                                        >
                                            <PlusOutlined />
                                            新增可購買性規則
                                        </a-button>
                                    </div>
                                    <template v-else>
                                        <div class="compact-table-wrap">
                                            <div class="rules-table-header">
                                                <span class="col-type">
                                                    受眾類型
                                                </span>
                                                <span class="col-ref">
                                                    受眾
                                                </span>
                                                <span class="col-action">
                                                    操作
                                                </span>
                                            </div>
                                            <div
                                                v-for="(
                                                    rule, index
                                                ) in productForm.purchasable_rules"
                                                :key="index"
                                                class="rules-table-row"
                                            >
                                                <div class="col-type">
                                                    <a-select
                                                        v-model:value="
                                                            rule.audience_type
                                                        "
                                                        :options="
                                                            getRuleTypeOptions()
                                                        "
                                                        placeholder="選擇"
                                                        size="small"
                                                        class="input-full"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'purchasable',
                                                                    index
                                                                )
                                                        "
                                                    />
                                                </div>
                                                <div class="col-ref">
                                                    <a-select
                                                        v-if="
                                                            getRuleTypeDataOptions(
                                                                rule.audience_type
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        option-filter-prop="label"
                                                        :options="
                                                            getRuleTypeDataOptions(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        :placeholder="
                                                            getRuleTypePlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        size="small"
                                                        class="input-full"
                                                        allow-clear
                                                    />
                                                    <a-select
                                                        v-else-if="
                                                            rule.audience_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'purchasable',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'purchasable',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員（可多選）"
                                                        size="small"
                                                        class="input-full"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'purchasable',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    />
                                                </div>
                                                <div class="col-action">
                                                    <a-button
                                                        type="text"
                                                        danger
                                                        size="small"
                                                        @click="
                                                            removePurchasableRule(
                                                                index
                                                            )
                                                        "
                                                    >
                                                        <DeleteOutlined />
                                                    </a-button>
                                                </div>
                                            </div>
                                        </div>
                                        <a-button
                                            type="link"
                                            size="small"
                                            class="add-compact-link"
                                            @click="addPurchasableRule"
                                        >
                                            <PlusOutlined />
                                            新增可購買性規則
                                        </a-button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>

                    <a-tab-pane key="sales">
                        <template #tab>
                            <span class="tab-label-wrap">
                                支付與點數
                                <a-badge
                                    v-if="tabErrorKeys.includes('sales')"
                                    status="error"
                                    class="tab-error-badge"
                                />
                            </span>
                        </template>
                        <div class="tab-pane-content">
                            <!-- 點數抵扣區塊（緊湊表格式） -->
                            <div class="form-section">
                                <div class="form-section-title">點數抵扣</div>
                                <div class="discount-compact">
                                    <div
                                        v-if="
                                            productForm.point_discounts
                                                .length === 0
                                        "
                                        class="compact-empty"
                                    >
                                        <a-button
                                            type="dashed"
                                            block
                                            @click="addDiscount"
                                            size="small"
                                        >
                                            <PlusOutlined />
                                            新增點數抵扣
                                        </a-button>
                                    </div>
                                    <template v-else>
                                        <div class="compact-table-wrap">
                                            <div class="discount-table-header">
                                                <span class="col-point-type">
                                                    點數類型
                                                </span>
                                                <span class="col-mode">
                                                    折抵模式
                                                </span>
                                                <span class="col-value">
                                                    折抵數值
                                                </span>
                                                <span class="col-action">
                                                    操作
                                                </span>
                                            </div>
                                            <div
                                                v-for="(
                                                    point, idx
                                                ) in productForm.point_discounts"
                                                :key="idx"
                                                class="discount-table-row"
                                            >
                                                <div class="col-point-type">
                                                    <a-select
                                                        v-model:value="
                                                            point.point_type
                                                        "
                                                        :options="pointTypes"
                                                        placeholder="選擇"
                                                        allow-clear
                                                        size="small"
                                                        class="input-full"
                                                    />
                                                </div>
                                                <div class="col-mode">
                                                    <a-select
                                                        v-model:value="
                                                            point.mode
                                                        "
                                                        :options="pointModes"
                                                        placeholder="模式"
                                                        allow-clear
                                                        size="small"
                                                        class="input-full"
                                                    />
                                                </div>
                                                <div class="col-value">
                                                    <a-input-number
                                                        v-model:value="
                                                            point.value
                                                        "
                                                        :placeholder="
                                                            point.mode === 1
                                                                ? '比例'
                                                                : point.mode ===
                                                                    0
                                                                  ? '金額'
                                                                  : '—'
                                                        "
                                                        :min="0"
                                                        :precision="0"
                                                        :step="1"
                                                        :disabled="
                                                            point.mode === null
                                                        "
                                                        size="small"
                                                        class="input-full"
                                                    />
                                                </div>
                                                <div class="col-action">
                                                    <a-button
                                                        type="text"
                                                        danger
                                                        size="small"
                                                        @click="
                                                            removeDiscount(idx)
                                                        "
                                                    >
                                                        <DeleteOutlined />
                                                    </a-button>
                                                </div>
                                            </div>
                                        </div>
                                        <a-button
                                            type="link"
                                            size="small"
                                            class="add-compact-link"
                                            @click="addDiscount"
                                        >
                                            <PlusOutlined />
                                            新增點數抵扣
                                        </a-button>
                                    </template>
                                </div>
                            </div>

                            <!-- 商品支付方式區塊（緊湊表格式） -->
                            <div class="form-section">
                                <div class="form-section-title">
                                    商品支付方式
                                </div>
                                <a-alert
                                    type="info"
                                    show-icon
                                    class="payment-methods-hint"
                                    message="同一商品請勿同時綁定兩組藍新帳號；前台選項顯示名稱相同，實際會依所選付款方式進入對應商店。"
                                    style="margin-bottom: 8px"
                                />
                                <div class="payment-methods-compact">
                                    <div
                                        v-if="
                                            productForm.product_payment_methods
                                                .length === 0
                                        "
                                        class="payment-methods-empty"
                                    >
                                        <a-button
                                            type="dashed"
                                            block
                                            @click="addProductPaymentMethod"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增支付方式
                                        </a-button>
                                    </div>
                                    <template v-else>
                                        <div class="payment-methods-table-wrap">
                                            <div
                                                class="payment-methods-table-header"
                                            >
                                                <span class="col-payment">
                                                    付款方式
                                                </span>
                                                <span class="col-name">
                                                    顯示名稱
                                                </span>
                                                <span class="col-installment">
                                                    期數
                                                </span>
                                                <span class="col-total">
                                                    總額
                                                </span>
                                                <span class="col-action">
                                                    操作
                                                </span>
                                            </div>
                                            <div
                                                v-for="(
                                                    pm, pidx
                                                ) in productForm.product_payment_methods"
                                                :key="pidx"
                                                class="payment-methods-table-row"
                                            >
                                                <div class="col-payment">
                                                    <a-select
                                                        v-model:value="
                                                            pm.payment_method_id
                                                        "
                                                        :options="
                                                            paymentMethodsOptions
                                                        "
                                                        placeholder="選擇"
                                                        allow-clear
                                                        size="small"
                                                        class="input-full"
                                                        @change="
                                                            onPaymentMethodChange(
                                                                pm
                                                            )
                                                        "
                                                    />
                                                </div>
                                                <div class="col-name">
                                                    <a-input
                                                        v-model:value="pm.name"
                                                        placeholder="例：一次付清"
                                                        size="small"
                                                        class="input-full"
                                                    />
                                                </div>
                                                <div class="col-installment">
                                                    <a-select
                                                        v-if="
                                                            hasMultipleInstallments(
                                                                pm.payment_method_id
                                                            )
                                                        "
                                                        v-model:value="
                                                            pm.installment
                                                        "
                                                        :options="
                                                            getInstallmentOptions(
                                                                pm.payment_method_id
                                                            )
                                                        "
                                                        size="small"
                                                        class="input-full installment-select"
                                                        dropdown-class-name="installment-select-dropdown"
                                                        :dropdown-style="{
                                                            minWidth: '120px'
                                                        }"
                                                        @change="
                                                            onInstallmentChange(
                                                                pm
                                                            )
                                                        "
                                                    />
                                                    <span
                                                        v-else
                                                        class="installment-once"
                                                    >
                                                        一次付清
                                                    </span>
                                                </div>
                                                <div class="col-total">
                                                    <a-input-number
                                                        v-model:value="pm.price"
                                                        :min="0"
                                                        :precision="0"
                                                        placeholder="選填"
                                                        size="small"
                                                        class="input-full"
                                                    />
                                                    <span
                                                        v-if="
                                                            pm.installment >
                                                                0 &&
                                                            pm.price !==
                                                                undefined &&
                                                            pm.price !== null &&
                                                            pm.price !== ''
                                                        "
                                                        class="per-installment-hint"
                                                    >
                                                        每期約
                                                        {{
                                                            getPerInstallmentPrice(
                                                                pm
                                                            )
                                                        }}
                                                        元
                                                    </span>
                                                </div>
                                                <div class="col-action">
                                                    <a-button
                                                        type="text"
                                                        danger
                                                        size="small"
                                                        @click="
                                                            removeProductPaymentMethod(
                                                                pidx
                                                            )
                                                        "
                                                    >
                                                        <DeleteOutlined />
                                                    </a-button>
                                                </div>
                                            </div>
                                        </div>
                                        <a-button
                                            type="link"
                                            size="small"
                                            class="add-payment-method-link"
                                            @click="addProductPaymentMethod"
                                        >
                                            <PlusOutlined />
                                            新增支付方式
                                        </a-button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>

                    <a-tab-pane key="purchase">
                        <template #tab>
                            <span class="tab-label-wrap">購買前要求</span>
                        </template>
                        <div class="tab-pane-content">
                            <div class="form-section">
                                <div class="form-section-title">購買前流程</div>
                                <a-form-item
                                    label="要求類型"
                                    class="form-item-full"
                                >
                                    <a-radio-group
                                        v-model:value="
                                            productForm.purchase_requirement_type
                                        "
                                    >
                                        <a-radio value="none">
                                            無（直接加購物車）
                                        </a-radio>
                                        <a-radio value="consent">
                                            勾選同意
                                        </a-radio>
                                        <a-radio value="contract">
                                            簽署契約
                                        </a-radio>
                                    </a-radio-group>
                                </a-form-item>

                                <div class="purchase-journey-card">
                                    <div class="purchase-journey-card__title">
                                        學員會經歷的步驟
                                    </div>
                                    <ol class="purchase-journey-card__steps">
                                        <template
                                            v-if="
                                                productForm.purchase_requirement_type ===
                                                'none'
                                            "
                                        >
                                            <li>商品頁直接加入購物車</li>
                                            <li>結帳付款 → 物品入背包</li>
                                            <li>至「活動報名」選場次填表</li>
                                        </template>
                                        <template
                                            v-else-if="
                                                productForm.purchase_requirement_type ===
                                                'consent'
                                            "
                                        >
                                            <li>商品頁勾選同意條款</li>
                                            <li>
                                                加入購物車並結帳 → 物品入背包
                                            </li>
                                            <li>至「活動報名」選場次填表</li>
                                        </template>
                                        <template v-else>
                                            <li>
                                                商品頁進入契約簽署（填資料 →
                                                簽名）
                                            </li>
                                            <li>簽署完成後加入購物車並結帳</li>
                                            <li>至「活動報名」選場次填表</li>
                                        </template>
                                    </ol>
                                    <div class="purchase-journey-card__links">
                                        <a-button
                                            type="link"
                                            size="small"
                                            @click="
                                                openPurchaseRequirementSettings
                                            "
                                        >
                                            前往同意與契約設定
                                        </a-button>
                                    </div>
                                </div>
                                <a-form-item
                                    v-if="
                                        productForm.purchase_requirement_type ===
                                        'consent'
                                    "
                                    label="同意條款組"
                                    class="form-item-full"
                                >
                                    <a-select
                                        v-model:value="
                                            productForm.consent_profile_id
                                        "
                                        :options="consentProfileOptions"
                                        placeholder="選擇共用同意條款組"
                                        allow-clear
                                        show-search
                                        option-filter-prop="label"
                                    />
                                </a-form-item>
                                <a-form-item
                                    v-if="
                                        productForm.purchase_requirement_type ===
                                        'contract'
                                    "
                                    label="契約範本"
                                    class="form-item-full"
                                >
                                    <a-select
                                        v-model:value="
                                            productForm.contract_template_id
                                        "
                                        :options="contractTemplateOptions"
                                        placeholder="選擇契約範本"
                                        allow-clear
                                        show-search
                                        option-filter-prop="label"
                                    />
                                </a-form-item>
                                <div
                                    v-if="
                                        productForm.purchase_requirement_type ===
                                        'consent'
                                    "
                                    class="form-section"
                                >
                                    <div class="form-section-title">
                                        商品專屬追加勾選（選填）
                                    </div>
                                    <p class="form-section-hint">
                                        若此商品需額外同意條款，可在此新增並填寫條款全文
                                    </p>
                                    <a-empty
                                        v-if="
                                            !productForm.extra_consent_items
                                                .length
                                        "
                                        description="尚未新增專屬勾選項"
                                    />
                                    <a-collapse
                                        v-else
                                        v-model:activeKey="
                                            extraConsentExpandedKey
                                        "
                                        accordion
                                        :bordered="false"
                                        expand-icon-position="end"
                                        class="extra-consent-collapse"
                                    >
                                        <a-collapse-panel
                                            v-for="(
                                                item, idx
                                            ) in productForm.extra_consent_items"
                                            :key="item._uid || idx"
                                        >
                                            <template #header>
                                                <div
                                                    class="extra-consent-collapse__header"
                                                >
                                                    <span
                                                        class="extra-consent-collapse__idx"
                                                    >
                                                        {{ idx + 1 }}
                                                    </span>
                                                    <span
                                                        class="extra-consent-collapse__title"
                                                    >
                                                        {{
                                                            summarizeExtraConsentLabel(
                                                                item.label
                                                            )
                                                        }}
                                                    </span>
                                                    <a-tag
                                                        v-if="item.required"
                                                        class="extra-consent-collapse__tag"
                                                    >
                                                        必填
                                                    </a-tag>
                                                    <a-tag
                                                        :color="
                                                            item.content?.trim()
                                                                ? 'green'
                                                                : 'orange'
                                                        "
                                                        class="extra-consent-collapse__tag"
                                                    >
                                                        {{
                                                            item.content?.trim()
                                                                ? '已填條款'
                                                                : '缺條款'
                                                        }}
                                                    </a-tag>
                                                </div>
                                            </template>
                                            <template #extra>
                                                <a-button
                                                    type="text"
                                                    danger
                                                    size="small"
                                                    @click.stop="
                                                        removeExtraConsentItem(
                                                            idx
                                                        )
                                                    "
                                                >
                                                    刪除
                                                </a-button>
                                            </template>
                                            <a-form-item
                                                label="前台顯示文字"
                                                class="extra-consent-field"
                                            >
                                                <a-input
                                                    v-model:value="item.label"
                                                    placeholder="我已閱讀並同意《…》"
                                                />
                                            </a-form-item>
                                            <a-form-item
                                                label="條款全文"
                                                class="extra-consent-field"
                                            >
                                                <a-textarea
                                                    v-model:value="item.content"
                                                    placeholder="貼上完整條款內容；有填寫時使用者需滑到底才可勾選"
                                                    :rows="6"
                                                    show-count
                                                    :maxlength="50000"
                                                />
                                            </a-form-item>
                                            <a-checkbox
                                                v-model:checked="item.required"
                                            >
                                                此項為必填
                                            </a-checkbox>
                                        </a-collapse-panel>
                                    </a-collapse>
                                    <a-button
                                        type="dashed"
                                        block
                                        @click="addExtraConsentItem"
                                    >
                                        新增專屬勾選項
                                    </a-button>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>

                    <a-tab-pane key="image">
                        <template #tab>
                            <span class="tab-label-wrap">
                                圖片
                                <a-badge
                                    v-if="tabErrorKeys.includes('image')"
                                    status="error"
                                    class="tab-error-badge"
                                />
                            </span>
                        </template>
                        <div class="tab-pane-content">
                            <!-- 商品圖片區塊 -->
                            <div class="form-section">
                                <div class="form-section-title">商品圖片</div>
                                <a-form-item
                                    name="cover_image"
                                    class="form-item-full"
                                >
                                    <div class="image-upload-area">
                                        <!-- 注意事項 -->
                                        <div class="image-upload-tips">
                                            <div class="tip-item">
                                                <span class="tip-icon">📋</span>
                                                <span class="tip-text">
                                                    <strong>支援格式</strong>
                                                    ：JPEG / JPG / PNG / GIF /
                                                    WebP
                                                </span>
                                            </div>
                                            <div class="tip-item">
                                                <span class="tip-icon">📏</span>
                                                <span class="tip-text">
                                                    建議尺寸：
                                                    <strong>1600 × 1000</strong>
                                                    像素
                                                </span>
                                            </div>
                                            <div class="tip-item">
                                                <span class="tip-icon">💾</span>
                                                <span class="tip-text">
                                                    檔案大小：最大
                                                    <strong>2MB</strong>
                                                    （建議 500KB - 1MB）
                                                </span>
                                            </div>
                                        </div>

                                        <div
                                            v-if="
                                                imagePreviewUrl ||
                                                productForm.cover_image_url
                                            "
                                            class="image-preview"
                                        >
                                            <img
                                                :src="
                                                    imagePreviewUrl ||
                                                    resolveUploadAssetUrl(
                                                        productForm.cover_image_url
                                                    )
                                                "
                                                alt="商品預覽圖"
                                                class="preview-image"
                                            />
                                            <a-button
                                                type="text"
                                                danger
                                                class="remove-image-btn"
                                                @click="handleRemoveImage"
                                            >
                                                <DeleteOutlined />
                                            </a-button>
                                        </div>
                                        <a-upload
                                            v-model:file-list="
                                                productForm.preview_cover_image
                                            "
                                            action=""
                                            name="file"
                                            :max-count="1"
                                            :show-upload-list="false"
                                            :before-upload="handleBeforeUpload"
                                            accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                                            @change="handleImgChange"
                                            @remove="handleImgRemove"
                                        >
                                            <a-button
                                                type="dashed"
                                                size="large"
                                                class="upload-btn"
                                            >
                                                <template #icon>
                                                    <PlusOutlined />
                                                </template>
                                                {{
                                                    imagePreviewUrl ||
                                                    productForm.cover_image_url
                                                        ? '更換圖片'
                                                        : '上傳圖片'
                                                }}
                                            </a-button>
                                        </a-upload>
                                    </div>
                                </a-form-item>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </a-form>
        </a-modal>

        <!-- 刪除商品確認 Modal -->
        <a-modal
            v-model:open="deleteModalVisible"
            title="刪除商品"
            :width="600"
            :confirm-loading="deleteLoading"
            @ok="() => handleDelete(deleteTarget?.id)"
            @cancel="() => (deleteModalVisible = false)"
        >
            <div v-if="deleteTarget" class="delete-modal-content">
                <!-- 商品資訊 -->
                <div class="delete-product-info">
                    <h3 class="delete-section-title">商品資訊</h3>
                    <a-descriptions :column="2" bordered size="small">
                        <a-descriptions-item label="商品名稱" :span="2">
                            <span class="product-name-display">
                                {{ deleteTarget.name }}
                            </span>
                        </a-descriptions-item>
                        <a-descriptions-item
                            v-if="deleteTarget.subtitle"
                            label="商品副標題"
                            :span="2"
                        >
                            {{ deleteTarget.subtitle }}
                        </a-descriptions-item>
                        <a-descriptions-item label="商品分類">
                            <a-tag
                                v-if="deleteTarget.category_name"
                                color="purple"
                            >
                                {{ deleteTarget.category_name }}
                            </a-tag>
                            <span v-else>-</span>
                        </a-descriptions-item>
                        <a-descriptions-item label="商品類型">
                            <a-tag :class="getTypeTagClass(deleteTarget.type)">
                                {{
                                    typeOpt.find(
                                        (t) => t.value === deleteTarget.type
                                    )
                                        ? typeOpt.find(
                                              (t) =>
                                                  t.value === deleteTarget.type
                                          )['label']
                                        : '-'
                                }}
                            </a-tag>
                        </a-descriptions-item>
                        <a-descriptions-item label="商品狀態">
                            <a-tag
                                :color="
                                    getStatusColor(
                                        deleteTarget.status ||
                                            deleteTarget.effective_status
                                    )
                                "
                            >
                                {{
                                    statusOpt.find(
                                        (s) =>
                                            s.value ===
                                            (deleteTarget.status ||
                                                deleteTarget.effective_status)
                                    )
                                        ? statusOpt.find(
                                              (s) =>
                                                  s.value ===
                                                  (deleteTarget.status ||
                                                      deleteTarget.effective_status)
                                          )['label']
                                        : '-'
                                }}
                            </a-tag>
                        </a-descriptions-item>
                        <a-descriptions-item label="商品價格">
                            <span class="product-price-display">
                                {{
                                    deleteTarget.price
                                        ? deleteTarget.price.toLocaleString()
                                        : 0
                                }}
                                元
                            </span>
                        </a-descriptions-item>
                        <a-descriptions-item label="庫存數量">
                            <a-tag
                                :class="
                                    getStockTagClass(deleteTarget.stock_qty)
                                "
                            >
                                <span
                                    v-if="
                                        isUnlimitedStock(deleteTarget.stock_qty)
                                    "
                                    class="unlimited-symbol"
                                >
                                    ∞ 無限量
                                </span>
                                <span v-else>
                                    {{ deleteTarget.stock_qty ?? 0 }}
                                </span>
                            </a-tag>
                        </a-descriptions-item>
                        <a-descriptions-item label="是否需要寄送">
                            <a-tag
                                :color="
                                    deleteTarget.requires_shipping === 1 ||
                                    deleteTarget.requires_shipping === true
                                        ? 'blue'
                                        : 'default'
                                "
                            >
                                {{
                                    deleteTarget.requires_shipping === 1 ||
                                    deleteTarget.requires_shipping === true
                                        ? '是'
                                        : '否'
                                }}
                            </a-tag>
                        </a-descriptions-item>
                        <a-descriptions-item
                            v-if="
                                deleteTarget.per_user_max_qty &&
                                deleteTarget.per_user_max_qty > 0
                            "
                            label="最大購買數量"
                        >
                            {{ deleteTarget.per_user_max_qty }} 件
                        </a-descriptions-item>
                    </a-descriptions>
                </div>

                <!-- 操作提示 -->
                <div class="delete-action-hint" style="margin-top: 16px">
                    <a-alert
                        type="warning"
                        message="此操作無法復原，請確認後再執行"
                        show-icon
                    />
                </div>
            </div>
            <template #footer>
                <a-button @click="deleteModalVisible = false">取消</a-button>
                <a-button
                    type="primary"
                    danger
                    :loading="deleteLoading"
                    @click="() => handleDelete(deleteTarget?.id)"
                >
                    確認刪除
                </a-button>
            </template>
        </a-modal>

        <div class="page-header">
            <h1>商品列表</h1>
            <p>查看並管理所有的商品</p>
        </div>

        <div class="content light-theme">
            <!-- 工具欄 -->
            <div class="toolbar">
                <!-- 篩選標籤區域（分類、類型、狀態） -->
                <div class="filters-section">
                    <!-- 分類標籤篩選 -->
                    <div class="filter-tags-section">
                        <span class="filter-label">分類：</span>
                        <div class="filter-tags">
                            <!-- 大分類與子分類 -->
                            <template
                                v-for="category in productCategories"
                                :key="category.id"
                            >
                                <!-- 大分類 -->
                                <div class="category-item-wrapper">
                                    <a-tag
                                        :class="{
                                            'filter-tag-active':
                                                categoryValue === category.id
                                        }"
                                        class="filter-tag filter-tag-parent clickable-tag"
                                        @click="
                                            handleCategoryClick(
                                                category.id,
                                                true
                                            )
                                        "
                                    >
                                        <span
                                            v-if="
                                                category.children &&
                                                category.children.length > 0
                                            "
                                            class="expand-icon"
                                            @click="
                                                toggleCategoryExpand(
                                                    category.id,
                                                    $event
                                                )
                                            "
                                        >
                                            <span
                                                v-if="
                                                    isCategoryExpanded(
                                                        category.id
                                                    )
                                                "
                                            >
                                                ▼
                                            </span>
                                            <span v-else>▶</span>
                                        </span>
                                        {{ category.name }}
                                        <span class="category-count">
                                            ({{
                                                getCategoryTotalCount(category)
                                            }})
                                        </span>
                                    </a-tag>

                                    <!-- 子分類（根據展開狀態顯示） -->
                                    <template
                                        v-if="
                                            category.children &&
                                            category.children.length > 0 &&
                                            isCategoryExpanded(category.id)
                                        "
                                    >
                                        <div
                                            class="category-children-container"
                                        >
                                            <a-tag
                                                v-for="child in category.children"
                                                :key="child.id"
                                                :class="{
                                                    'filter-tag-active':
                                                        categoryValue ===
                                                        child.id
                                                }"
                                                class="filter-tag filter-tag-child clickable-tag"
                                                @click="
                                                    handleCategoryClick(
                                                        child.id,
                                                        false
                                                    )
                                                "
                                            >
                                                {{ child.name }}
                                                <span class="category-count">
                                                    ({{
                                                        child.products_count ||
                                                        0
                                                    }})
                                                </span>
                                            </a-tag>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- 類型與狀態標籤篩選（同一行） -->
                    <div class="filter-tags-row">
                        <!-- 類型標籤篩選 -->
                        <div class="filter-tags-section">
                            <span class="filter-label">類型：</span>
                            <div class="filter-tags">
                                <a-tag
                                    v-for="type in typeOpt.filter(
                                        (t) => t.value !== null
                                    )"
                                    :key="type.value"
                                    :class="{
                                        'filter-tag-active':
                                            typeValue === type.value
                                    }"
                                    class="filter-tag clickable-tag"
                                    @click="handleTypeClick(type.value)"
                                >
                                    {{ type.label }}
                                </a-tag>
                            </div>
                        </div>

                        <!-- 狀態標籤篩選 -->
                        <div class="filter-tags-section">
                            <span class="filter-label">狀態：</span>
                            <div class="filter-tags">
                                <a-tag
                                    v-for="status in statusOpt.filter(
                                        (s) => s.value !== null
                                    )"
                                    :key="status.value"
                                    :class="{
                                        'filter-tag-active':
                                            statusValue === status.value
                                    }"
                                    class="filter-tag clickable-tag"
                                    @click="handleStatusClick(status.value)"
                                >
                                    {{ status.label }}
                                </a-tag>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 搜尋列和操作按鈕 -->
                <div class="search-section">
                    <div class="search-wrapper">
                        <a-input
                            v-model:value="searchText"
                            placeholder="搜尋商品名稱、副標題、描述"
                            size="middle"
                            class="search-input"
                            allow-clear
                            @press-enter="handleSearch"
                        />
                    </div>
                    <div class="filter-actions">
                        <a-button
                            size="middle"
                            class="unified-search-btn"
                            @click="handleSearch"
                        >
                            查詢
                        </a-button>
                        <a-button
                            size="middle"
                            class="unified-reset-btn"
                            @click="handleReset"
                        >
                            重置
                        </a-button>
                    </div>
                    <a-button
                        v-if="canCreate"
                        type="primary"
                        size="middle"
                        class="unified-add-btn"
                        @click="openAddModel"
                    >
                        新增商品
                    </a-button>
                </div>
            </div>
            <!-- 商品列表卡片 -->
            <div class="products-card-view">
                <a-spin :spinning="loading">
                    <div v-if="productList.length > 0" class="products-grid">
                        <div
                            v-for="product in productList"
                            :key="product.id"
                            :class="[
                                'product-card',
                                `product-card-${getEffectiveStatus(product)}`
                            ]"
                            @click="canView ? handleCardClick(product) : null"
                            :style="{
                                cursor: canView ? 'pointer' : 'default'
                            }"
                        >
                            <!-- 狀態提示條 -->
                            <div
                                v-if="
                                    product.effective_status || product.status
                                "
                                :class="[
                                    'product-status-banner',
                                    `status-banner-${getEffectiveStatus(product)}`
                                ]"
                            >
                                <span class="status-banner-text">
                                    {{
                                        getStatusBannerText(
                                            getEffectiveStatus(product)
                                        )
                                    }}
                                </span>
                            </div>
                            <!-- 操作按鈕（懸浮在右上角） -->
                            <div class="product-card-actions">
                                <a-button
                                    v-if="canEdit"
                                    type="text"
                                    size="small"
                                    class="action-btn edit-btn"
                                    @click.stop="goEdit(product)"
                                    title="編輯"
                                >
                                    <template #icon>
                                        <EditOutlined />
                                    </template>
                                </a-button>
                                <a-button
                                    v-if="canDelete"
                                    type="text"
                                    size="small"
                                    class="action-btn delete-btn"
                                    @click.stop="openDeleteModal(product)"
                                    title="刪除"
                                >
                                    <template #icon>
                                        <DeleteOutlined />
                                    </template>
                                </a-button>
                            </div>

                            <!-- 商品圖片 -->
                            <div class="product-card-image">
                                <div
                                    v-if="canEdit"
                                    class="product-card-sort"
                                    @click.stop
                                >
                                    <SortStepper
                                        :loading="movingProductId === product.id"
                                        @up="moveProduct(product, 'up')"
                                        @down="moveProduct(product, 'down')"
                                    />
                                </div>
                                <!-- 類型標籤（左上角） -->
                                <div class="product-type-badge">
                                    <a-tag
                                        :class="getTypeTagClass(product.type)"
                                        size="small"
                                    >
                                        {{
                                            typeOpt.find(
                                                (t) => t.value === product.type
                                            )
                                                ? typeOpt.find(
                                                      (t) =>
                                                          t.value ===
                                                          product.type
                                                  )['label']
                                                : '-'
                                        }}
                                    </a-tag>
                                </div>

                                <!-- 購買前要求（左下角） -->
                                <div
                                    v-if="getPurchaseRequirementBadge(product)"
                                    class="product-requirement-badge"
                                    :class="`product-requirement-badge--${getPurchaseRequirementBadge(product).kind}`"
                                    :title="
                                        getPurchaseRequirementBadge(product)
                                            .title
                                    "
                                >
                                    <FileProtectOutlined
                                        v-if="
                                            getPurchaseRequirementBadge(product)
                                                .kind === 'contract'
                                        "
                                        class="product-requirement-badge__icon"
                                    />
                                    <FileTextOutlined
                                        v-else
                                        class="product-requirement-badge__icon"
                                    />
                                </div>

                                <!-- 轉成背包標記（右下角，有背景） -->
                                <div
                                    v-if="
                                        product.convert_to_inventory === true ||
                                        product.convert_to_inventory === 1
                                    "
                                    class="product-inventory-badge"
                                    title="會轉成背包物品"
                                >
                                    <InboxOutlined
                                        class="inventory-badge-icon"
                                    />
                                </div>

                                <img
                                    v-if="
                                        product.cover_image_url &&
                                        !product.imageError
                                    "
                                    :src="
                                        resolveUploadAssetUrl(
                                            product.cover_image_url
                                        )
                                    "
                                    :alt="product.name"
                                    class="product-cover-image"
                                    @error="handleImageError($event, product)"
                                />
                                <div
                                    v-else-if="product.imageError"
                                    class="product-image-error"
                                >
                                    <span>載入失敗</span>
                                </div>
                                <div v-else class="product-image-placeholder">
                                    <span>無圖片</span>
                                </div>

                                <!-- 時間提醒（圖片下方中間） -->
                                <div
                                    v-if="getTimeReminder(product)"
                                    :class="[
                                        'product-time-reminder',
                                        `time-reminder-${getTimeReminderType(product)}`
                                    ]"
                                >
                                    {{ getTimeReminder(product) }}
                                </div>
                            </div>

                            <!-- 商品資訊 -->
                            <div class="product-card-body">
                                <!-- 商品名稱 -->
                                <div class="product-card-name">
                                    <div class="product-name-row">
                                        <div class="product-name">
                                            {{ product.name }}
                                        </div>
                                        <EnrollmentReadinessPill
                                            v-if="product.enrollment_readiness"
                                            :readiness="
                                                product.enrollment_readiness
                                            "
                                            compact
                                        />
                                    </div>
                                    <div
                                        v-if="product.subtitle"
                                        class="product-subtitle"
                                    >
                                        {{ product.subtitle }}
                                    </div>
                                </div>

                                <!-- 商品標籤 -->
                                <div class="product-tags">
                                    <!-- 分類 -->
                                    <a-tag
                                        v-if="product.category_name"
                                        color="purple"
                                        size="small"
                                    >
                                        {{ product.category_name }}
                                    </a-tag>

                                    <!-- 庫存狀態 -->
                                    <a-tag
                                        :class="
                                            getStockTagClass(product.stock_qty)
                                        "
                                        size="small"
                                    >
                                        庫存：
                                        <span
                                            v-if="
                                                isUnlimitedStock(
                                                    product.stock_qty
                                                )
                                            "
                                            class="unlimited-symbol"
                                        >
                                            ∞
                                        </span>
                                        <span v-else>
                                            {{ product.stock_qty ?? 0 }}
                                        </span>
                                    </a-tag>

                                    <!-- 是否需要寄送（只顯示需寄送的） -->
                                    <a-tag
                                        v-if="
                                            product.requires_shipping === 1 ||
                                            product.requires_shipping === true
                                        "
                                        class="shipping-tag-yes"
                                        size="small"
                                    >
                                        需寄送
                                    </a-tag>

                                    <!-- 限購數量 -->
                                    <a-tag
                                        v-if="
                                            product.per_user_max_qty &&
                                            product.per_user_max_qty > 0
                                        "
                                        class="max-qty-tag"
                                        size="small"
                                    >
                                        限購 {{ product.per_user_max_qty }} 件
                                    </a-tag>
                                </div>

                                <!-- 支援支付方式：小 icon + 名稱，空則顯示紅色提醒標籤 -->
                                <div
                                    v-if="
                                        product.paymentMethodNames &&
                                        product.paymentMethodNames.length > 0
                                    "
                                    class="product-payment-hint"
                                >
                                    <CreditCardOutlined
                                        class="payment-hint-icon"
                                    />
                                    <span class="payment-hint-tags">
                                        <a-tooltip
                                            :title="
                                                product.paymentMethodNames.join(
                                                    '、'
                                                )
                                            "
                                        >
                                            <span>
                                                <template
                                                    v-for="(
                                                        name, i
                                                    ) in product.paymentMethodNames.slice(
                                                        0,
                                                        2
                                                    )"
                                                    :key="`${name}-${i}`"
                                                >
                                                    <span
                                                        v-if="i > 0"
                                                        class="payment-hint-sep"
                                                    >
                                                        、
                                                    </span>
                                                    <span
                                                        class="payment-hint-name"
                                                    >
                                                        {{ name }}
                                                    </span>
                                                </template>
                                                <span
                                                    v-if="
                                                        product
                                                            .paymentMethodNames
                                                            .length > 2
                                                    "
                                                    class="payment-hint-more"
                                                >
                                                    +{{
                                                        product
                                                            .paymentMethodNames
                                                            .length - 2
                                                    }}
                                                </span>
                                            </span>
                                        </a-tooltip>
                                    </span>
                                </div>
                                <a-tag
                                    v-else
                                    class="payment-unset-tag"
                                    size="small"
                                >
                                    <CreditCardOutlined
                                        class="payment-unset-icon"
                                    />
                                    尚未設定支付方式
                                </a-tag>

                                <!-- 商品價格 -->
                                <div class="product-card-price">
                                    <span class="price-label">價格：</span>
                                    <span class="price-value">
                                        ${{
                                            product.price?.toLocaleString(
                                                'zh-TW'
                                            ) || 0
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 空狀態 -->
                    <div v-else class="empty-products">
                        <p>暫無商品資料</p>
                    </div>

                    <!-- 分頁 -->
                    <div
                        v-if="productList.length > 0"
                        class="pagination-wrapper"
                    >
                        <a-pagination
                            v-model:current="pagination.current"
                            v-model:page-size="pagination.pageSize"
                            :total="pagination.total"
                            :show-size-changer="true"
                            :show-quick-jumper="true"
                            :page-size-options="['10', '20', '50', '100']"
                            :show-total="(total) => `總共 ${total} 筆`"
                            size="small"
                            position="bottomCenter"
                            :locale="{
                                items_per_page: '筆/頁',
                                jump_to: '跳至',
                                jump_to_confirm: '確定',
                                page: '頁',
                                prev_page: '上一頁',
                                next_page: '下一頁',
                                prev_5: '向前 5 頁',
                                next_5: '向后 5 頁'
                            }"
                            @change="handlePaginationChange"
                            @show-size-change="handlePaginationChange"
                        />
                    </div>
                </a-spin>
            </div>
        </div>
    </div>

    <!-- 查看商品詳情 Modal -->
    <a-modal
        v-model:open="viewModalVisible"
        :title="productDetail?.name || '商品詳情'"
        :width="720"
        :footer="null"
        :mask-closable="true"
        class="product-detail-modal"
    >
        <a-spin :spinning="detailLoading">
            <div v-if="productDetail" class="product-detail-view">
                <!-- 商品圖片與基本資訊 -->
                <div class="detail-top-section">
                    <div class="detail-image-wrapper">
                        <img
                            v-if="
                                canShowInventoryThumb(
                                    productDetail.cover_image_url,
                                    'product-cover'
                                )
                            "
                            :src="
                                resolveUploadAssetUrl(
                                    productDetail.cover_image_url
                                )
                            "
                            alt=""
                            class="detail-cover-image"
                            @error="onInventoryThumbError('product-cover')"
                        />
                        <div v-else class="detail-image-placeholder">
                            <PictureOutlined />
                        </div>
                        <div class="detail-type-badge">
                            <a-tag
                                :class="getTypeTagClass(productDetail.type)"
                                size="small"
                            >
                                {{
                                    typeOpt.find(
                                        (t) => t.value === productDetail.type
                                    )?.label || '-'
                                }}
                            </a-tag>
                        </div>
                    </div>
                    <div class="detail-basic-info">
                        <div
                            v-if="productDetail.subtitle"
                            class="detail-subtitle"
                        >
                            {{ productDetail.subtitle }}
                        </div>
                        <div class="detail-header-meta">
                            <div class="detail-status-row">
                                <a-tag
                                    :class="`detail-status-tag detail-status-tag-${productDetail.effective_status}`"
                                    size="small"
                                >
                                    {{
                                        getStatusBannerText(
                                            productDetail.effective_status
                                        )
                                    }}
                                </a-tag>
                                <a-tag
                                    v-if="
                                        productDetail.status &&
                                        productDetail.status !==
                                            productDetail.effective_status
                                    "
                                    class="detail-status-tag detail-status-tag-draft"
                                    size="small"
                                >
                                    設定：{{
                                        getStatusBannerText(
                                            productDetail.status
                                        )
                                    }}
                                </a-tag>
                                <a-tag
                                    v-if="
                                        productDetail.requires_shipping === 1 ||
                                        productDetail.requires_shipping === true
                                    "
                                    class="detail-shipping-tag"
                                    size="small"
                                >
                                    需寄送
                                </a-tag>
                            </div>
                            <div class="detail-price">
                                <span class="price-label">價格</span>
                                <span class="price-value">
                                    NT$
                                    {{
                                        productDetail.price?.toLocaleString(
                                            'zh-TW'
                                        ) || 0
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 詳細資訊區塊標題 -->
                <div class="detail-section-title">詳細資訊</div>
                <div class="detail-info-grid">
                    <div class="detail-info-item">
                        <span class="info-label">商品類型</span>
                        <a-tag
                            :class="getTypeTagClass(productDetail.type)"
                            size="small"
                        >
                            {{
                                typeOpt.find(
                                    (t) => t.value === productDetail.type
                                )?.label || '-'
                            }}
                        </a-tag>
                    </div>
                    <div class="detail-info-item">
                        <span class="info-label">商品分類</span>
                        <a-tag color="purple" size="small">
                            {{ productDetail.category?.name || '-' }}
                        </a-tag>
                    </div>
                    <div class="detail-info-item">
                        <span class="info-label">庫存數量</span>
                        <span class="info-value stock-value">
                            {{
                                productDetail.stock_qty === null ||
                                productDetail.stock_qty === undefined
                                    ? '∞'
                                    : productDetail.stock_qty
                            }}
                        </span>
                    </div>
                    <div class="detail-info-item">
                        <span class="info-label">限購數量</span>
                        <span class="info-value">
                            {{
                                productDetail.per_user_max_qty
                                    ? `${productDetail.per_user_max_qty} 件`
                                    : '無限制'
                            }}
                        </span>
                    </div>
                    <div
                        v-if="productDetail.publish_at"
                        class="detail-info-item"
                    >
                        <span class="info-label">上架時間</span>
                        <span class="info-value info-value-mono">
                            {{
                                dayjs(productDetail.publish_at).format(
                                    'YYYY-MM-DD HH:mm'
                                )
                            }}
                        </span>
                    </div>
                    <div
                        v-if="productDetail.unpublish_at"
                        class="detail-info-item"
                    >
                        <span class="info-label">下架時間</span>
                        <span class="info-value info-value-mono">
                            {{
                                dayjs(productDetail.unpublish_at).format(
                                    'YYYY-MM-DD HH:mm'
                                )
                            }}
                        </span>
                    </div>
                </div>

                <!-- 發放物品 -->
                <div
                    v-if="productDetail.items && productDetail.items.length > 0"
                    class="detail-block"
                >
                    <div class="detail-section-title">發放物品</div>
                    <div class="detail-items-list">
                        <div
                            v-for="item in productDetail.items"
                            :key="item.id"
                            class="detail-item-row"
                        >
                            <div class="detail-item-thumb-wrap">
                                <img
                                    v-if="
                                        canShowInventoryThumb(
                                            item.cover_image_url,
                                            item.id
                                        )
                                    "
                                    :src="
                                        resolveUploadAssetUrl(
                                            item.cover_image_url
                                        )
                                    "
                                    alt=""
                                    class="detail-item-thumb"
                                    @error="onInventoryThumbError(item.id)"
                                />
                                <div
                                    v-else
                                    class="detail-item-thumb-placeholder"
                                >
                                    <PictureOutlined />
                                </div>
                            </div>
                            <div class="detail-item-info">
                                <div class="detail-item-name">
                                    {{ item.name }}
                                </div>
                                <div class="detail-item-tags">
                                    <a-tag
                                        :color="detailItemTypeColor(item.type)"
                                        size="small"
                                    >
                                        {{ detailItemTypeLabel(item.type) }}
                                    </a-tag>
                                    <a-tag
                                        :color="detailRarityColor(item.rarity)"
                                        size="small"
                                    >
                                        {{ detailRarityLabel(item.rarity) }}
                                    </a-tag>
                                    <a-tag
                                        v-if="item.item_type"
                                        color="default"
                                        size="small"
                                    >
                                        {{ item.item_type.display_name }}
                                    </a-tag>
                                    <span class="detail-item-bind">
                                        {{
                                            item.bind_type === 'bound'
                                                ? '帳號綁定'
                                                : '可轉移'
                                        }}
                                    </span>
                                </div>
                            </div>
                            <div class="detail-item-qty">
                                <span class="detail-item-qty-label">數量</span>
                                <span class="detail-item-qty-value">
                                    × {{ item.pivot?.qty ?? 1 }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 支付方式 -->
                <div
                    v-if="
                        productDetail.payment_methods &&
                        productDetail.payment_methods.length > 0
                    "
                    class="detail-block"
                >
                    <div class="detail-section-title">支付方式</div>
                    <div class="detail-payment-methods">
                        <a-tag
                            v-for="pm in productDetail.payment_methods"
                            :key="pm.id"
                            class="detail-payment-tag"
                        >
                            {{ pm.name }}
                        </a-tag>
                    </div>
                </div>

                <!-- 點數抵扣 -->
                <div
                    v-if="
                        productDetail.point_discounts &&
                        productDetail.point_discounts.length > 0
                    "
                    class="detail-block"
                >
                    <div class="detail-section-title">點數抵扣</div>
                    <div class="point-discounts-list">
                        <div
                            v-for="(
                                discount, idx
                            ) in productDetail.point_discounts"
                            :key="idx"
                            class="point-discount-item"
                        >
                            <span class="discount-type">
                                {{ discount.point_type_code || '-' }}
                            </span>
                            <a-tag
                                :color="discount.mode === 0 ? 'purple' : 'cyan'"
                                size="small"
                            >
                                {{ discount.mode === 0 ? '固定值' : '百分比' }}
                            </a-tag>
                            <span class="discount-value">
                                {{ discount.value }}
                                <span v-if="discount.mode === 1">%</span>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- 商品描述 -->
                <div v-if="productDetail.description" class="detail-block">
                    <div class="detail-section-title">商品描述</div>
                    <div class="description-text">
                        {{ productDetail.description }}
                    </div>
                </div>
            </div>
        </a-spin>
    </a-modal>
</template>

<script setup>
import {
    ref,
    reactive,
    onMounted,
    computed,
    toRaw,
    watch,
    h,
    nextTick
} from 'vue';
import { message } from 'ant-design-vue';
import { showErrorMessage, handleApiError } from '@/utils/messageHelper';
import { buildConsentItemsPayload } from '@/utils/slugifyConsentKey';
import {
    fetchAllShopCategoryRows,
    createShopProducts,
    getShopProducts,
    getShopProduct,
    updateShopProducts,
    deleteShopProducts,
    moveShopProduct,
    getShopProductOptions,
    listVendors
} from '@/api/products';
import {
    getConsentProfileOptions,
    getContractTemplateOptions
} from '@/api/products/purchaseRequirement';
import { getInventoryItems } from '@/api/inventory-items';
import { getPointTypes } from '@/api/points';
import { getPaymentMethods } from '@/api/payment-methods';
import { searchUsers } from '@/api/users';
import { fetchAllOptionRows } from '@/utils/safePaginatedFetch';
import { useRouter, useRoute } from 'vue-router';
import dayjs from 'dayjs';
import { applyStartOfDay, applyEndOfDay } from '@/utils/dateTimePicker';
import { resolveUploadAssetUrl } from '@/utils/resolveUploadAssetUrl';
import { useAdminInfo } from '@/stores/useAdminInfo';
import EnrollmentReadinessPill from '@/components/forms/EnrollmentReadinessPill.vue';
import SortStepper from '@/components/common/SortStepper.vue';

import {
    PlusOutlined,
    MinusOutlined,
    SearchOutlined,
    EditOutlined,
    DeleteOutlined,
    PictureOutlined,
    CreditCardOutlined,
    InboxOutlined,
    FileProtectOutlined,
    FileTextOutlined
} from '@ant-design/icons-vue';

const router = useRouter();
const route = useRoute();
const adminStore = useAdminInfo();

// 權限檢查
const canCreate = computed(() => adminStore.hasPermissionCode('150201')); // 新增商品
const canEdit = computed(() => adminStore.hasPermissionCode('150202')); // 修改商品
const canDelete = computed(() => adminStore.hasPermissionCode('150203')); // 刪除商品
const canView = computed(() => adminStore.hasPermissionCode('150204')); // 查看商品
const canManageStock = computed(() => adminStore.hasPermissionCode('150205')); // 管理庫存

const loading = ref(false);
const movingProductId = ref(null);
const searchText = ref('');
const productCategories = ref([]);
const productList = ref([]);
const pointTypes = ref([]);
const form = ref(null);
const categoryValue = ref(null);
const typeValue = ref(null);
const statusValue = ref(null);
const selectedParentCategory = ref(null); // 追蹤選中的大分類
const expandedCategories = ref(new Set()); // 追蹤展開的分類
const open = ref(false);
const productFormActiveTab = ref('basic');
const tabErrorKeys = ref([]);
const deleteModalVisible = ref(false);
const deleteLoading = ref(false);
const deleteTarget = ref(null);

/** 表單欄位對應到 Tab key，用於驗證失敗時標示並切換到錯誤分頁 */
const FIELD_TO_TAB = {
    name: 'basic',
    category_id: 'basic',
    subtitle: 'basic',
    description: 'basic',
    type: 'basic',
    status: 'basic',
    requires_shipping: 'basic',
    price: 'basic',
    stock_qty: 'basic',
    per_user_max_qty: 'basic',
    publish_at: 'basic',
    unpublish_at: 'basic',
    items: 'inventory',
    cover_image: 'image'
};
const productForm = ref({
    name: null,
    subtitle: null,
    description: null,
    type: null,
    price: 0,
    category_id: null,
    stock_qty: null,
    per_user_max_qty: 0,
    status: null,
    cover_image: null,
    cover_image_url: null,
    imageError: false,
    cover_image_changed: false, // 標記圖片是否有改變
    original_cover_image_url: null, // 原始圖片 URL（用於判斷是否改變）
    requires_shipping: null,
    items: [],
    publish_at: null,
    unpublish_at: null,
    point_discounts: [],
    product_payment_methods: [],
    visibility_rules: [],
    purchasable_rules: [],
    purchase_requirement_type: 'none',
    consent_profile_id: null,
    contract_template_id: null,
    extra_consent_items: [],
    vendor_id: null
});

const vendors = ref([]);
const consignmentVendors = computed(() =>
    vendors.value.filter((vendor) => !vendor.is_house)
);
const showVendorField = computed(() => consignmentVendors.value.length > 0);
const vendorOptions = computed(() =>
    consignmentVendors.value.map((vendor) => ({
        value: vendor.id,
        label: vendor.name
    }))
);

const consentProfileOptions = ref([]);
const contractTemplateOptions = ref([]);
const extraConsentExpandedKey = ref(undefined);

const openPurchaseRequirementSettings = () => {
    window.open('/forms/purchase-requirements', '_blank');
};

const loadPurchaseRequirementOptions = async () => {
    try {
        const [profilesRes, templatesRes] = await Promise.all([
            getConsentProfileOptions(),
            getContractTemplateOptions()
        ]);
        consentProfileOptions.value = (profilesRes?.data || []).map((p) => ({
            value: p.id,
            label: p.name
        }));
        contractTemplateOptions.value = (templatesRes?.data || []).map((t) => ({
            value: t.id,
            label: `${t.name}${t.is_default ? '（預設）' : ''}`
        }));
    } catch (e) {
        console.error('載入購買前設定選項失敗', e);
    }
};

let extraConsentItemUid = 0;
const nextExtraConsentItemUid = () => {
    extraConsentItemUid += 1;
    return `eci-${extraConsentItemUid}`;
};

const addExtraConsentItem = () => {
    productForm.value.extra_consent_items.push({
        _uid: nextExtraConsentItemUid(),
        key: '',
        label: '',
        content: '',
        required: true
    });
};

const summarizeExtraConsentLabel = (label) => {
    const text = (label || '').trim();
    return text || '（未命名）';
};

const removeExtraConsentItem = (idx) => {
    const item = productForm.value.extra_consent_items[idx];
    productForm.value.extra_consent_items.splice(idx, 1);
    if (item && extraConsentExpandedKey.value === item._uid) {
        extraConsentExpandedKey.value = undefined;
    }
};

const imagePreviewUrl = ref(null);

// 分頁設定
const pagination = reactive({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 筆`
});

// 表格欄位
const columns = [
    {
        title: '商品圖片',
        key: 'cover_image',
        dataIndex: 'cover_image_url',
        width: 100,
        align: 'center'
    },
    {
        title: '商品名稱',
        key: 'name',
        dataIndex: 'name',
        width: 200,
        align: 'left'
    },
    {
        title: '商品分類',
        key: 'category_name',
        dataIndex: 'category_name',
        width: 120,
        align: 'center'
    },
    {
        title: '商品類型',
        key: 'type',
        dataIndex: 'type',
        width: 100,
        align: 'center'
    },
    {
        title: '商品價格',
        key: 'price',
        dataIndex: 'price',
        width: 120,
        align: 'center'
    },
    {
        title: '庫存量',
        key: 'stock_qty',
        dataIndex: 'stock_qty',
        width: 100,
        align: 'center'
    },
    {
        title: '商品狀態',
        key: 'status',
        dataIndex: 'status',
        width: 100,
        align: 'center'
    },
    {
        title: '可購買',
        key: 'can_purchase',
        dataIndex: 'can_purchase',
        width: 100,
        align: 'center'
    },
    {
        title: '操作',
        key: 'actions',
        align: 'center',
        fixed: 'right',
        width: 120
    }
];

const typeOpt = [
    { label: '全部', value: null },
    { label: '實體', value: 'physical' },
    { label: '虛擬', value: 'virtual' },
    { label: '課程', value: 'course' },
    { label: '票卷', value: 'ticket' }
];

const statusOpt = [
    { label: '全部', value: null },
    { label: '草稿', value: 'draft' },
    { label: '上架', value: 'active' },
    { label: '下架', value: 'inactive' }
];

/** value 對應中文顏色名，用於稀有度顯示「普通 (白)」 */
/** 物品搜尋選項 */
const inventoryItemOptions = ref([]);
const inventoryItemLoading = ref(false);
/** 新增物品 picker 狀態 */
const newItemId = ref(null);
const newItemQty = ref(1);
let _itemSearchTimer = null;

const formRules = {
    name: [{ required: true, message: '請輸入商品名稱' }],
    type: [{ required: true, message: '請輸入商品類型' }],
    price: [{ required: true, message: '請輸入商品價格' }],
    category_id: [{ required: true, message: '請輸入商品分類' }]
};

const pointModes = ref([
    { label: '固定值', value: 0 },
    { label: '百分比', value: 1 }
]);

const paymentMethodsOptions = ref([]);
/** 付款方式完整列表（含 supported_installments），供期數選項與預設名稱使用 */
const paymentMethodsList = ref([]);

// 載入商品列表
const loadProducts = async () => {
    try {
        loading.value = true;

        const params = {
            page: pagination.current,
            per_page: pagination.pageSize
        };

        // 關鍵字搜尋
        if (searchText.value) {
            params['keyword'] = searchText.value;
        }

        // 分類篩選
        if (categoryValue.value) {
            params['category_id'] = categoryValue.value;
        }

        // 商品類型
        if (typeValue.value) {
            params['type'] = typeValue.value;
        }

        // 商品有效狀態
        if (statusValue.value) {
            params['effective_status'] = statusValue.value;
        }

        const response = await getShopProducts(params);

        if (response.result) {
            productList.value = (response.data.data || []).map((product) => ({
                ...product,
                imageError: false, // 重置圖片錯誤狀態
                paymentMethodNames: getProductPaymentMethodNames({
                    product_payment_methods: product.product_payment_methods
                })
            }));
            pagination.total = response.data.pagination.total || 0;
            pagination.current = response.data.pagination.current_page || 1;
        } else {
            showErrorMessage(response.message || '載入失敗');
        }
    } catch (error) {
        showErrorMessage('載入商品清單失敗');
    } finally {
        loading.value = false;
    }
};

const moveProduct = async (product, direction) => {
    if (!canEdit.value) {
        showErrorMessage('您沒有修改商品的權限');
        return;
    }

    try {
        movingProductId.value = product.id;
        const response = await moveShopProduct(product.id, direction);
        if (response.result) {
            message.success('排序已更新');
            await loadProducts();
        } else {
            showErrorMessage(response.message || '排序更新失敗');
        }
    } catch (error) {
        const { response } = error;
        const { data } = response || {};
        showErrorMessage(data?.message || error?.message || '排序更新失敗');
    } finally {
        movingProductId.value = null;
    }
};

// 載入商品分類（自動翻頁，避免一次要 per_page=10000）
const loadCategories = async () => {
    try {
        productCategories.value = await fetchAllShopCategoryRows();
    } catch (error) {
        showErrorMessage('載入商品分類失敗');
    }
};

// 載入付款方式選項（供商品支付方式下拉使用，含 supported_installments）
const loadPaymentMethods = async () => {
    try {
        const list = await fetchAllOptionRows((params) =>
            getPaymentMethods({ ...params, status: 1 })
        );
        paymentMethodsList.value = list;
        paymentMethodsOptions.value = list.map((p) => ({
            label: p.name,
            value: p.id
        }));
    } catch (error) {
        console.error('載入付款方式失敗:', error);
    }
};

/** 依付款方式 ID 取得期數選項（0=一次付清，其餘為 X期）；僅當支援多期數時使用 */
const getInstallmentOptions = (paymentMethodId) => {
    const method = paymentMethodsList.value.find(
        (p) => p.id === paymentMethodId
    );
    const arr = method?.supported_installments;
    if (!arr || !Array.isArray(arr) || arr.length === 0) return [];
    return arr.map((n) => ({
        label: n === 0 ? '一次付清' : `${n}期`,
        value: n
    }));
};

/** 該付款方式是否可選多種期數（>1 才顯示期數下拉） */
const hasMultipleInstallments = (paymentMethodId) => {
    const method = paymentMethodsList.value.find(
        (p) => p.id === paymentMethodId
    );
    const arr = method?.supported_installments;
    return arr && Array.isArray(arr) && arr.length > 1;
};

/** 預設顯示名稱：0 期 = 金流名稱，其餘 = 金流名稱前兩字 + X期 */
const getDefaultPaymentMethodName = (paymentMethodId, installment) => {
    const method = paymentMethodsList.value.find(
        (p) => p.id === paymentMethodId
    );
    if (!method || !method.name) return '';
    const name = method.name;
    if (installment === 0 || installment === undefined || installment === null)
        return name;
    const prefix = name.slice(0, 2);
    return `${prefix}${installment}期`;
};

/** 選擇付款方式時：固定期數為該方式第一個支援期數（僅 [0] 則為一次付清），並帶入預設名稱 */
const onPaymentMethodChange = (pm) => {
    const method = paymentMethodsList.value.find(
        (p) => p.id === pm.payment_method_id
    );
    const arr = method?.supported_installments;
    const first = arr && arr.length > 0 ? arr[0] : 0;
    pm.installment = first;
    pm.name = getDefaultPaymentMethodName(pm.payment_method_id, first);
};

/** 選擇期數時：帶入預設名稱 */
const onInstallmentChange = (pm) => {
    pm.name = getDefaultPaymentMethodName(pm.payment_method_id, pm.installment);
};

/** 表單中「總額」試算每期金額：總額 ÷ 期數取整（僅供顯示） */
const getPerInstallmentPrice = (pm) => {
    const total =
        pm.price !== undefined && pm.price !== null && pm.price !== ''
            ? Number(pm.price)
            : 0;
    const inst = pm.installment > 0 ? Number(pm.installment) : 1;
    return Math.floor(total / inst);
};

// 載入積分選項
const loadPointTypes = async () => {
    try {
        loading.value = true;
        const list = await fetchAllOptionRows((params) => getPointTypes(params));
        pointTypes.value = list.map((d) => ({
            label: d.code,
            value: d.id
        }));
    } catch (error) {
        showErrorMessage('載入積分類型失敗');
    } finally {
        loading.value = false;
    }
};

// 規則選項數據
const audienceTypes = ref([]); // 從 API 獲取的受眾類型選項

// 用戶搜尋狀態
const userSearchState = reactive({
    visibility: {},
    purchasable: {}
});

const userSearchLoading = reactive({
    visibility: {},
    purchasable: {}
});

// 載入商品選項（受眾類型等）
const loadProductOptions = async () => {
    try {
        const response = await getShopProductOptions();
        if (!response.result || !response.data) return;
        const data = response.data;
        if (data.audience_types) {
            audienceTypes.value = data.audience_types;
        }
    } catch (error) {
        console.error('載入商品選項失敗:', error);
    }
};

// 獲取規則類型選項
const getRuleTypeOptions = () => {
    const options = audienceTypes.value.map((type) => ({
        label: type.label,
        value: type.value
    }));
    // 添加「單一用戶」選項（如果 API 沒有返回）
    if (!options.find((opt) => opt.value === 'user')) {
        options.push({ label: '單一用戶', value: 'user' });
    }
    return options;
};

// ===== 發放物品 =====
const ITEM_TYPE_LABELS = {
    virtual: '一般道具',
    ticket: '票券',
    physical: '實體兌換'
};
const ITEM_TYPE_COLORS = {
    virtual: 'purple',
    ticket: 'cyan',
    physical: 'orange'
};

const getItemTypeLabel = (type) => ITEM_TYPE_LABELS[type] ?? type ?? '-';
const getItemTypeColor = (type) => ITEM_TYPE_COLORS[type] ?? 'default';

const loadInventoryItemOptions = async (keyword = '') => {
    inventoryItemLoading.value = true;
    try {
        const res = await getInventoryItems({ keyword, per_page: 50 });
        const list = res.data?.data ?? res.data ?? [];
        inventoryItemOptions.value = list.map((i) => ({
            value: i.id,
            label: i.name,
            type: i.type,
            cover_image_url: i.cover_image_url ?? null
        }));
    } catch {
        inventoryItemOptions.value = [];
    } finally {
        inventoryItemLoading.value = false;
    }
};

const handleItemSearchInit = () => {
    if (inventoryItemOptions.value.length === 0) loadInventoryItemOptions();
};

const handleItemSearch = (keyword) => {
    clearTimeout(_itemSearchTimer);
    _itemSearchTimer = setTimeout(() => loadInventoryItemOptions(keyword), 300);
};

const selectedNewItem = computed(() => {
    return inventoryItemOptions.value.find((o) => o.value === newItemId.value);
});

watch(selectedNewItem, (item) => {
    if (item?.type === 'ticket') {
        newItemQty.value = 1;
    }
});

const addProductItem = () => {
    if (!newItemId.value) {
        message.warning('請先選擇物品');
        return;
    }
    const found = inventoryItemOptions.value.find(
        (o) => o.value === newItemId.value
    );
    const qty = newItemQty.value;
    if (!qty || qty < 1) {
        message.warning('數量至少為 1');
        return;
    }
    if (
        productForm.value.items.some(
            (i) => i.inventory_item_id === newItemId.value
        )
    ) {
        message.warning('此物品已加入，請直接修改數量');
        return;
    }
    productForm.value.items.push({
        inventory_item_id: newItemId.value,
        qty: Math.max(1, Math.floor(qty)),
        name: found?.label ?? `#${newItemId.value}`,
        type: found?.type ?? '',
        cover_image_url: found?.cover_image_url ?? null
    });
    newItemId.value = null;
    newItemQty.value = 1;
};

const removeProductItem = (idx) => {
    productForm.value.items.splice(idx, 1);
};

const inventoryThumbErrors = ref({});

const inventoryThumbKey = (id) => String(id ?? '');

const canShowInventoryThumb = (url, id) =>
    Boolean(url) && !inventoryThumbErrors.value[inventoryThumbKey(id)];

const onInventoryThumbError = (id) => {
    inventoryThumbErrors.value = {
        ...inventoryThumbErrors.value,
        [inventoryThumbKey(id)]: true
    };
};

const resetInventoryThumbErrors = () => {
    inventoryThumbErrors.value = {};
};

// 獲取規則類型對應的選項列表
const getRuleTypeDataOptions = (audienceType) => {
    if (!audienceType) return [];

    const typeConfig = audienceTypes.value.find(
        (t) => t.value === audienceType
    );
    if (!typeConfig || !typeConfig.options) return [];

    return typeConfig.options.map((option) => {
        // role 類型：使用 value（字串，如 "guest"）
        if (audienceType === 'role') {
            return {
                label: option.label,
                value: option.value
            };
        }
        // department 和 rank 類型：使用 id
        else if (option.id !== undefined) {
            return {
                label: option.name || option.label,
                value: option.id
            };
        }
        // 其他情況：使用 value 或 id
        else {
            return {
                label: option.label || option.name,
                value: option.value || option.id
            };
        }
    });
};

// 獲取規則類型的 placeholder
const getRuleTypePlaceholder = (audienceType) => {
    const placeholders = {
        role: '選擇角色',
        rank: '選擇聘階',
        grade: '選擇聘級',
        department: '選擇事業部',
        user: '搜尋會員'
    };
    return placeholders[audienceType] || '請選擇';
};

// 用戶搜尋相關函數
const getUserSearchOptions = (type, index) => {
    return userSearchState[type]?.[index] || [];
};

const getUserSearchLoading = (type, index) => {
    return userSearchLoading[type]?.[index] || false;
};

const handleUserSearch = async (type, index, keyword) => {
    if (!keyword || keyword.trim() === '') {
        if (!userSearchState[type]) userSearchState[type] = {};
        userSearchState[type][index] = [];
        return;
    }

    // 檢查關鍵字長度，至少需要 2 個字元
    const trimmedKeyword = keyword.trim();
    if (trimmedKeyword.length < 2) {
        if (!userSearchState[type]) userSearchState[type] = {};
        userSearchState[type][index] = [];
        return;
    }

    try {
        if (!userSearchLoading[type]) userSearchLoading[type] = {};
        userSearchLoading[type][index] = true;
        const response = await searchUsers({ name: trimmedKeyword });
        if (!userSearchState[type]) userSearchState[type] = {};
        userSearchState[type][index] =
            (response.data || []).map((user) => ({
                label: user.name || user.username,
                value: user.id
            })) || [];
    } catch (error) {
        // 如果是 422 錯誤（參數驗證失敗），只記錄不顯示錯誤
        if (error.response && error.response.status === 422) {
            console.log('搜尋參數不符合要求，請輸入至少 2 個字元');
            if (!userSearchState[type]) userSearchState[type] = {};
            userSearchState[type][index] = [];
        } else {
            console.error('搜尋會員失敗:', error);
            if (!userSearchState[type]) userSearchState[type] = {};
            userSearchState[type][index] = [];
        }
    } finally {
        if (userSearchLoading[type]) {
            userSearchLoading[type][index] = false;
        }
    }
};

// 添加規則
const addVisibilityRule = () => {
    productForm.value.visibility_rules.push({
        audience_type: undefined,
        audience_ref: []
    });
};

const removeVisibilityRule = (index) => {
    productForm.value.visibility_rules.splice(index, 1);
};

const addPurchasableRule = () => {
    productForm.value.purchasable_rules.push({
        audience_type: undefined,
        audience_ref: []
    });
};

const removePurchasableRule = (index) => {
    productForm.value.purchasable_rules.splice(index, 1);
};

// 處理規則類型變更
const handleRuleTypeChange = (ruleType, index) => {
    if (ruleType === 'visibility') {
        productForm.value.visibility_rules[index].audience_ref = [];
    } else {
        productForm.value.purchasable_rules[index].audience_ref = [];
    }
};

// 處理分頁變化
const handlePaginationChange = (page, pageSize) => {
    pagination.current = page;
    pagination.pageSize = pageSize;
    loadProducts();
};

// 處理分類標籤點擊
const handleCategoryClick = (categoryId, isParent = false) => {
    if (categoryValue.value === categoryId) {
        // 如果點擊已選中的分類，則取消選擇
        categoryValue.value = null;
        selectedParentCategory.value = null;
    } else {
        categoryValue.value = categoryId;
        // 如果是大分類，記錄選中的大分類以便顯示子分類
        if (isParent) {
            selectedParentCategory.value = categoryId;
            // 自動展開父分類以顯示子分類
            const category = productCategories.value.find(
                (c) => c.id === categoryId
            );
            if (category && category.children && category.children.length > 0) {
                expandedCategories.value.add(categoryId);
            }
        } else {
            // 如果是子分類，清除大分類選擇
            selectedParentCategory.value = null;
        }
    }
    pagination.current = 1;
    loadProducts();
};

// 獲取大分類的商品總數（包含所有子分類的商品數）
const getCategoryTotalCount = (category) => {
    // 如果是子分類，直接返回自己的數量
    if (category.parent_id) {
        return category.products_count || 0;
    }

    // 如果是大分類，計算自己 + 所有子分類的數量
    let total = category.products_count || 0;

    // 遞迴計算所有子分類的商品數
    if (category.children && Array.isArray(category.children)) {
        category.children.forEach((child) => {
            total += child.products_count || 0;
        });
    }

    return total;
};

// 切換分類展開/收合狀態
const toggleCategoryExpand = (categoryId, event) => {
    event.stopPropagation(); // 阻止觸發分類點擊事件
    if (expandedCategories.value.has(categoryId)) {
        expandedCategories.value.delete(categoryId);
    } else {
        expandedCategories.value.add(categoryId);
    }
};

// 檢查分類是否展開
const isCategoryExpanded = (categoryId) => {
    return expandedCategories.value.has(categoryId);
};

// 將分類樹狀結構轉換為 TreeSelect 可用格式（保留層級）
const categoryTreeDataForForm = computed(() => {
    const toNode = (cat) => ({
        label: cat.name,
        value: cat.id,
        children: Array.isArray(cat.children)
            ? cat.children.map((c) => ({
                  label: c.name,
                  value: c.id
              }))
            : undefined
    });

    return Array.isArray(productCategories.value)
        ? productCategories.value.map(toNode)
        : [];
});

// 處理類型標籤點擊
const handleTypeClick = (type) => {
    if (typeValue.value === type) {
        // 如果點擊已選中的類型，則取消選擇
        typeValue.value = null;
    } else {
        typeValue.value = type;
    }
    pagination.current = 1;
    loadProducts();
};

// 處理狀態標籤點擊
const handleStatusClick = (status) => {
    if (statusValue.value === status) {
        // 如果點擊已選中的狀態，則取消選擇
        statusValue.value = null;
    } else {
        statusValue.value = status;
    }
    pagination.current = 1;
    loadProducts();
};

// 處理圖片載入錯誤
const handleImageError = (event, product) => {
    // 標記該商品圖片載入失敗
    product.imageError = true;
    // 隱藏圖片元素
    event.target.style.display = 'none';
};

// 獲取類型標籤的樣式類別
const getTypeTagClass = (type) => {
    const typeClassMap = {
        physical: 'type-tag-physical',
        virtual: 'type-tag-virtual',
        course: 'type-tag-course',
        ticket: 'type-tag-ticket'
    };
    return typeClassMap[type] || 'type-tag-default';
};

// 判斷是否為無限量庫存
const isUnlimitedStock = (stockQty) => {
    return stockQty === null || stockQty === undefined;
};

// 獲取狀態顏色
const getStatusColor = (status) => {
    const colorMap = {
        draft: 'default',
        active: 'green',
        inactive: 'red'
    };
    return colorMap[status] || 'default';
};

// 獲取庫存標籤樣式類別
const getStockTagClass = (stockQty) => {
    if (stockQty === null || stockQty === undefined) {
        return 'stock-tag-unlimited';
    }
    if (stockQty === 0) {
        return 'stock-tag-zero';
    }
    if (stockQty > 0 && stockQty <= 10) {
        return 'stock-tag-low';
    }
    if (stockQty > 10) {
        return 'stock-tag-normal';
    }
    return 'stock-tag-normal';
};

/** 從 product_payment_methods 依付款方式分組，顯示為「金流名稱(一次付清、3期、6期...)」；銀行僅一次付清時不括號 */
const getProductPaymentMethodNames = (product) => {
    const list = product?.product_payment_methods;
    if (!list || !list.length) return [];
    const byMethod = {};
    list.forEach((item) => {
        const method = item.payment_method;
        const id = method?.id ?? item.payment_method_id;
        const name = method?.name || item.name;
        const code = method?.code ?? '';
        if (!id || !name) return;
        if (!byMethod[id])
            byMethod[id] = { name, code, installments: new Set() };
        const inst =
            item.installment !== undefined && item.installment !== null
                ? Number(item.installment)
                : 0;
        byMethod[id].installments.add(inst);
    });
    const isBank = (code, name) =>
        code === 'bank_transfer' || (name && name.includes('銀行'));
    return Object.values(byMethod).map(({ name, code, installments }) => {
        const hasZero = installments.has(0);
        const nonZero = [...installments]
            .filter((n) => n !== 0)
            .sort((a, b) => a - b);
        const labels = [
            ...(hasZero ? ['一次付清'] : []),
            ...nonZero.map((n) => `${n}期`)
        ];
        if (labels.length === 0) return name;
        if (
            isBank(code, name) &&
            labels.length === 1 &&
            labels[0] === '一次付清'
        )
            return name;
        return `${name}(${labels.join('、')})`;
    });
};

/** 商品卡片：支付方式 tooltip 完整列表文字 */
const getPaymentMethodsTooltip = (product) => {
    const names = getProductPaymentMethodNames(product);
    return names.length ? names.join('、') : '';
};

// 獲取有效狀態（優先使用 effective_status）
const getEffectiveStatus = (product) => {
    return product.effective_status || product.status || 'draft';
};

// 獲取狀態提示條文字
const getStatusBannerText = (status) => {
    const statusTextMap = {
        draft: '草稿',
        scheduled: '排程中',
        active: '已上架',
        expired: '已過期',
        inactive: '已下架'
    };
    return statusTextMap[status] || '未知狀態';
};

// 獲取時間提醒文字（顯示在圖片下方中間）
const getTimeReminder = (product) => {
    const now = dayjs();
    const publishAt = product.publish_at ? dayjs(product.publish_at) : null;
    const unpublishAt = product.unpublish_at
        ? dayjs(product.unpublish_at)
        : null;

    // 如果上架時間在未來，顯示即將上架
    if (publishAt && publishAt.isAfter(now)) {
        return `即將上架 ${publishAt.format('MM/DD HH:mm')}`;
    }

    // 如果下架時間在未來，顯示下架時間
    if (unpublishAt && unpublishAt.isAfter(now)) {
        return `下架時間 ${unpublishAt.format('MM/DD HH:mm')}`;
    }

    // 如果已下架時間已過，顯示已下架
    if (unpublishAt && unpublishAt.isBefore(now)) {
        return `已下架 ${unpublishAt.format('MM/DD HH:mm')}`;
    }

    return null;
};

// 獲取時間提醒類型（用於設定不同顏色）
const getTimeReminderType = (product) => {
    const now = dayjs();
    const publishAt = product.publish_at ? dayjs(product.publish_at) : null;
    const unpublishAt = product.unpublish_at
        ? dayjs(product.unpublish_at)
        : null;

    // 如果上架時間在未來，返回 'upcoming'（淡綠色）
    if (publishAt && publishAt.isAfter(now)) {
        return 'upcoming';
    }

    // 如果下架時間在未來，返回 'unpublish'（橘色）
    if (unpublishAt && unpublishAt.isAfter(now)) {
        return 'unpublish';
    }

    // 如果已下架時間已過，返回 'default'（灰色）
    if (unpublishAt && unpublishAt.isBefore(now)) {
        return 'default';
    }

    return 'default';
};

/** 商品卡片：購買前要求圖示（同意／契約） */
const getPurchaseRequirementBadge = (product) => {
    const type = product?.purchase_requirement_type;
    if (type === 'contract') {
        return { kind: 'contract', title: '購買前須簽署契約' };
    }
    if (type === 'consent') {
        return { kind: 'consent', title: '購買前須同意條款' };
    }
    return null;
};

// 搜尋
const handleSearch = () => {
    pagination.current = 1;
    loadProducts();
};

// 重置篩選條件
const handleReset = () => {
    categoryValue.value = null;
    selectedParentCategory.value = null;
    typeValue.value = null;
    statusValue.value = null;
    searchText.value = '';
    pagination.current = 1;
    loadProducts();
};

const handleFormReset = () => {
    // 重置 id，確保是新增模式而非編輯模式
    productForm.value.id = undefined;
    productForm.value.name = null;
    productForm.value.subtitle = null;
    productForm.value.description = null;
    productForm.value.type = null;
    productForm.value.price = 0;
    productForm.value.category_id = null;
    productForm.value.vendor_id = null;
    productForm.value.stock_qty = null;
    productForm.value.per_user_max_qty = 0;
    productForm.value.status = null;
    productForm.value.cover_image = null;
    productForm.value.cover_image_url = null;
    productForm.value.imageError = false;
    productForm.value.cover_image_changed = false;
    productForm.value.original_cover_image_url = null;
    productForm.value.requires_shipping = null;
    productForm.value.items = [];
    resetInventoryThumbErrors();
    newItemId.value = null;
    newItemQty.value = 1;
    productForm.value.publish_at = null;
    productForm.value.unpublish_at = null;
    productForm.value.point_discounts = [];
    productForm.value.product_payment_methods = [];
    productForm.value.visibility_rules = [];
    productForm.value.purchasable_rules = [];
    productForm.value.purchase_requirement_type = 'none';
    productForm.value.consent_profile_id = null;
    productForm.value.contract_template_id = null;
    productForm.value.extra_consent_items = [];
    extraConsentExpandedKey.value = undefined;

    imagePreviewUrl.value = null;

    productFormActiveTab.value = 'basic';
    tabErrorKeys.value = [];

    // 重置表單驗證狀態
    nextTick(() => {
        form.value?.resetFields();
    });
};

const handlePublishAtChange = (date) => {
    productForm.value.publish_at = applyStartOfDay(date);
};

const handleUnpublishAtChange = (date) => {
    productForm.value.unpublish_at = applyEndOfDay(date);
};

// 刷新
const handleRefresh = () => {
    loadProducts();
};

const openDeleteModal = (product) => {
    deleteTarget.value = product;
    deleteModalVisible.value = true;
};

const handleDelete = async (id) => {
    if (!id) return;

    // 權限檢查
    if (!canDelete.value) {
        showErrorMessage('您沒有刪除商品的權限');
        return;
    }

    try {
        deleteLoading.value = true;
        const response = await deleteShopProducts(id);

        if (response.result) {
            message.success('刪除成功');
            deleteModalVisible.value = false;
            deleteTarget.value = null;
            loadProducts();
        } else {
            showErrorMessage(response.message || '刪除失敗');
        }
    } catch (error) {
        const { response } = error;
        const { data } = response || {};
        const errorMessage = data?.message || error?.message || '刪除失敗';
        showErrorMessage(errorMessage);
        console.error('刪除商品失敗:', error);
    } finally {
        deleteLoading.value = false;
    }
};

const handleEdit = async () => {
    const { id } = productForm.value;

    // 權限檢查
    if (id) {
        // 編輯商品
        if (!canEdit.value) {
            showErrorMessage('您沒有修改商品的權限');
            return;
        }
    } else {
        // 新增商品
        if (!canCreate.value) {
            showErrorMessage('您沒有新增商品的權限');
            return;
        }
    }

    // 表單驗證：失敗時標示有誤的 Tab 並切換到第一個錯誤分頁
    tabErrorKeys.value = [];
    try {
        await form.value?.validateFields();
    } catch (err) {
        const errorFields = err?.errorFields ?? [];
        const errorNames = errorFields.flatMap((f) => f.name || []);
        const tabsWithError = [
            ...new Set(errorNames.map((n) => FIELD_TO_TAB[n]).filter(Boolean))
        ];
        tabErrorKeys.value = tabsWithError;
        if (tabsWithError.length) {
            productFormActiveTab.value = tabsWithError[0];
        }
        message.warning('請檢查表單必填欄位');
        return;
    }

    // 安全地獲取圖片文件
    // 如果 cover_image 已經在 handleImgChange 中設置，就不需要從 preview_cover_image 獲取
    if (!productForm.value['cover_image']) {
        if (
            productForm.value['preview_cover_image'] &&
            Array.isArray(productForm.value['preview_cover_image']) &&
            productForm.value['preview_cover_image'].length > 0 &&
            productForm.value['preview_cover_image'][0]
        ) {
            // 優先使用 originFileObj，如果沒有則使用 file 本身
            const fileObj = productForm.value['preview_cover_image'][0];
            productForm.value['cover_image'] =
                fileObj['originFileObj'] || fileObj;
        }
    }

    let formData = new FormData();

    for (const [key, value] of Object.entries(productForm.value)) {
        // 跳過這些欄位，稍後單獨處理
        if (
            key === 'imageError' ||
            key === 'cover_image_url' ||
            key === 'cover_image' ||
            key === 'requires_shipping' ||
            key === 'cover_image_changed' ||
            key === 'original_cover_image_url' ||
            key === 'created_at' ||
            key === 'updated_at' ||
            key === 'effective_status' ||
            key === 'category' ||
            key === 'vendor' ||
            key === 'vendor_id' ||
            key === 'payment_methods' ||
            key === 'preview_cover_image' ||
            key === 'convert_to_inventory' ||
            key === 'inventory_granted_count' ||
            key === 'inventory_rarity' ||
            key === 'inventory_bind_type' ||
            key === 'inventory_item_type_id' ||
            key === 'inventory_expires_in_days'
        ) {
            continue;
        }

        if (key === 'product_payment_methods') {
            const valid = value.filter(
                (item) =>
                    item.payment_method_id != null &&
                    item.name != null &&
                    String(item.name).trim() !== ''
            );
            formData.append(
                'product_payment_methods',
                JSON.stringify(
                    valid.map((item) => {
                        const inst =
                            item.installment !== undefined &&
                            item.installment !== null
                                ? Number(item.installment)
                                : 0;
                        const price =
                            item.price !== undefined &&
                            item.price !== null &&
                            item.price !== ''
                                ? Number(item.price)
                                : undefined;
                        return {
                            payment_method_id: item.payment_method_id,
                            name: item.name.trim(),
                            installment: inst,
                            ...(price !== undefined ? { price } : {})
                        };
                    })
                )
            );
        } else if (key === 'extra_consent_items') {
            const valid = buildConsentItemsPayload(
                value || [],
                'product_consent'
            );
            formData.append('extra_consent_items', JSON.stringify(valid));
        } else if (key === 'point_discounts') {
            // 過濾掉空項目（point_type, mode, value 都為 null 的項目）
            const validDiscounts = value.filter(
                (discount) =>
                    discount.point_type !== null &&
                    discount.mode !== null &&
                    discount.value !== null
            );
            formData.append('point_discounts', JSON.stringify(validDiscounts));
        } else if (key === 'visibility_rules') {
            // 處理可見性規則：過濾掉空的規則，並轉換格式
            // 如果選擇了多個值，為每個值創建一個規則
            const validRules = [];
            value.forEach((rule) => {
                if (!rule.audience_type) return;

                let audienceRefs = rule.audience_ref;
                // 如果不是陣列，轉換為陣列
                if (!Array.isArray(audienceRefs)) {
                    if (audienceRefs !== undefined && audienceRefs !== null) {
                        audienceRefs = [audienceRefs];
                    } else {
                        return;
                    }
                }

                // 過濾掉空值
                audienceRefs = audienceRefs.filter(
                    (ref) => ref !== undefined && ref !== null && ref !== ''
                );

                // 為每個選中的值創建一個規則
                audienceRefs.forEach((audienceRef) => {
                    validRules.push({
                        audience_type: rule.audience_type,
                        audience_ref: String(audienceRef)
                    });
                });
            });

            // 不論有無規則都送出，清空時送 [] 讓 API 知道要清空
            formData.append('visibility_rules', JSON.stringify(validRules));
        } else if (key === 'purchasable_rules') {
            // 處理可購買性規則：過濾掉空的規則，並轉換格式
            // 如果選擇了多個值，為每個值創建一個規則
            const validRules = [];
            value.forEach((rule) => {
                if (!rule.audience_type) return;

                let audienceRefs = rule.audience_ref;
                // 如果不是陣列，轉換為陣列
                if (!Array.isArray(audienceRefs)) {
                    if (audienceRefs !== undefined && audienceRefs !== null) {
                        audienceRefs = [audienceRefs];
                    } else {
                        return;
                    }
                }

                // 過濾掉空值
                audienceRefs = audienceRefs.filter(
                    (ref) => ref !== undefined && ref !== null && ref !== ''
                );

                // 為每個選中的值創建一個規則
                audienceRefs.forEach((audienceRef) => {
                    validRules.push({
                        audience_type: rule.audience_type,
                        audience_ref: String(audienceRef)
                    });
                });
            });

            // 不論有無規則都送出，清空時送 [] 讓 API 知道要清空
            formData.append('purchasable_rules', JSON.stringify(validRules));
        } else if (key === 'publish_at' || key === 'unpublish_at') {
            // 處理 dayjs 對象
            if (value && dayjs.isDayjs(value)) {
                formData.append(key, value.format('YYYY-MM-DD HH:mm:ss'));
            } else if (value) {
                formData.append(key, value);
            } else {
                // 如果時間被清空，傳送空字串（後端會解析為 null）
                formData.append(key, '');
            }
        } else if (key === 'stock_qty') {
            // 處理庫存數量：空值或 undefined 設為 null（無限大），0 表示無庫存
            if (value === null || value === undefined || value === '') {
                formData.append(key, '');
            } else {
                formData.append(key, value);
            }
        } else if (key === 'per_user_max_qty') {
            // 處理最大購買數量：空值或 undefined 設為 null（無限制），0 也表示無限制
            if (
                value === null ||
                value === undefined ||
                value === '' ||
                value === 0
            ) {
                formData.append(key, '');
            } else {
                formData.append(key, value);
            }
        } else if (key === 'items') {
            const itemsList = (Array.isArray(value) ? value : []).map((i) => ({
                inventory_item_id: i.inventory_item_id,
                qty: i.qty
            }));
            formData.append('items', JSON.stringify(itemsList));
        } else if (value !== null && value !== undefined) {
            formData.append(key, value);
        }
    }

    formData.append(
        'vendor_id',
        productForm.value.vendor_id ? productForm.value.vendor_id : ''
    );

    // 明確處理 requires_shipping，確保總是傳送 true 或 false
    if (
        productForm.value.requires_shipping === null ||
        productForm.value.requires_shipping === undefined
    ) {
        // 如果為 null，根據產品類型設定預設值
        if (productForm.value.type === 'physical') {
            formData.append('requires_shipping', '1');
        } else {
            formData.append('requires_shipping', '0');
        }
    } else {
        // 確保傳送的是字串形式的 '1' 或 '0'
        formData.append(
            'requires_shipping',
            productForm.value.requires_shipping ? '1' : '0'
        );
    }

    if (id) {
        try {
            // 只有當圖片有改變時，才處理圖片相關參數
            if (productForm.value.cover_image_changed) {
                // 情況 1：上傳新圖片
                if (productForm.value['cover_image']) {
                    formData.append(
                        'cover_image',
                        productForm.value['cover_image']
                    );
                }
                // 情況 2：使用外部 URL 或清空圖片
                else if (productForm.value.imageError === true) {
                    // 清空圖片
                    formData.append('cover_image_url', '');
                } else if (
                    productForm.value.cover_image_url !== null &&
                    productForm.value.cover_image_url !== undefined
                ) {
                    // 使用外部 URL
                    formData.append(
                        'cover_image_url',
                        productForm.value.cover_image_url
                    );
                } else {
                    // 清空圖片（cover_image_url 為 null）
                    formData.append('cover_image_url', '');
                }
            }
            // 如果圖片沒有改變，不傳送任何圖片相關參數，後端會保留原有圖片

            // 由於 Laravel 處理 PUT/PATCH 請求時 FormData 的問題，
            // 通常會將 _method 設為 PUT/PATCH，但這裡我們直接在 API 層處理，
            // 所以直接傳遞 FormData 即可。
            const response = await updateShopProducts(id, formData);

            if (response.result) {
                message.success('更新成功');
                open.value = false;
                loadProducts();
                handleFormReset();
            } else {
                showErrorMessage(response.message || '更新失敗');
            }
        } catch (error) {
            console.error('更新商品失敗:', error);
            // 使用統一的錯誤處理函數
            handleApiError(error, '更新商品失敗', {
                name: '商品名稱',
                subtitle: '商品副標題',
                description: '商品描述',
                type: '商品類型',
                price: '商品價格',
                category_id: '商品分類',
                stock_qty: '庫存數量',
                per_user_max_qty: '每人限購數量',
                status: '商品狀態',
                cover_image: '商品圖片',
                requires_shipping: '需要運送',
                publish_at: '上架時間',
                unpublish_at: '下架時間'
            });
        }
    } else {
        // 新增商品時，如果有上傳圖片，也要處理
        if (productForm.value['cover_image']) {
            formData.append('cover_image', productForm.value['cover_image']);
        } else if (productForm.value.cover_image_url) {
            formData.append(
                'cover_image_url',
                productForm.value.cover_image_url
            );
        }

        try {
            const response = await createShopProducts(formData);

            if (response.result) {
                message.success('建立成功');
                open.value = false;
                handleFormReset();
                // 重置分頁到第一頁並重新載入列表
                pagination.current = 1;
                await loadProducts();
            } else {
                showErrorMessage(response.message || '建立失敗');
            }
        } catch (error) {
            console.error('建立商品失敗:', error);
            // 使用統一的錯誤處理函數
            handleApiError(error, '建立商品失敗', {
                name: '商品名稱',
                subtitle: '商品副標題',
                description: '商品描述',
                type: '商品類型',
                price: '商品價格',
                category_id: '商品分類',
                stock_qty: '庫存數量',
                per_user_max_qty: '每人限購數量',
                status: '商品狀態',
                cover_image: '商品圖片',
                requires_shipping: '需要運送',
                publish_at: '上架時間',
                unpublish_at: '下架時間'
            });
        }
    }
};

const goEdit = async (record) => {
    // 權限檢查
    if (!canEdit.value) {
        showErrorMessage('您沒有修改商品的權限');
        return;
    }

    try {
        // 調用 GET API 獲取最新資料
        const response = await getShopProduct(record.id);

        if (response.result && response.data) {
            const latestData = response.data;

            resetInventoryThumbErrors();
            // 使用最新資料填充表單
            productForm.value = structuredClone(latestData);
            await loadVendors();
            const selectedVendor = vendors.value.find(
                (vendor) => vendor.id === productForm.value.vendor_id
            );
            if (!selectedVendor || selectedVendor.is_house) {
                productForm.value.vendor_id = null;
            }
            productFormActiveTab.value = 'basic';
            tabErrorKeys.value = [];

            productForm.value['publish_at']
                ? (productForm.value['publish_at'] = dayjs(
                      productForm.value['publish_at']
                  ))
                : null;

            productForm.value['unpublish_at']
                ? (productForm.value['unpublish_at'] = dayjs(
                      productForm.value['unpublish_at']
                  ))
                : null;

            // 保存原始圖片 URL，用於判斷圖片是否有改變
            productForm.value.original_cover_image_url =
                productForm.value.cover_image_url;
            productForm.value.cover_image_changed = false;
            productForm.value.imageError = false;

            // 重置圖片預覽相關
            productForm.value.preview_cover_image = [];
            productForm.value.cover_image = null;
            imagePreviewUrl.value = resolveUploadAssetUrl(
                productForm.value.cover_image_url
            );

            // 轉換 requires_shipping：從布林值轉換為數字（1 或 0）
            if (
                productForm.value.requires_shipping === true ||
                productForm.value.requires_shipping === 1
            ) {
                productForm.value.requires_shipping = 1;
            } else if (
                productForm.value.requires_shipping === false ||
                productForm.value.requires_shipping === 0
            ) {
                productForm.value.requires_shipping = 0;
            } else {
                // 如果為 null 或 undefined，根據類型設定預設值
                if (productForm.value.type === 'physical') {
                    productForm.value.requires_shipping = 1;
                } else {
                    productForm.value.requires_shipping = 0;
                }
            }

            // 正規化 items：從 API 格式 [{id, name, type, pivot:{qty}}] 轉為表單格式
            productForm.value.items = (latestData.items ?? []).map((i) => ({
                inventory_item_id: i.id,
                qty: i.pivot?.qty ?? 1,
                name: i.name,
                type: i.type,
                cover_image_url: i.cover_image_url ?? null
            }));

            productForm.value.purchase_requirement_type =
                latestData.purchase_requirement_type || 'none';
            productForm.value.consent_profile_id =
                latestData.consent_profile_id ?? null;
            productForm.value.contract_template_id =
                latestData.contract_template_id ?? null;
            productForm.value.extra_consent_items = Array.isArray(
                latestData.extra_consent_items
            )
                ? latestData.extra_consent_items.map((item) => ({
                      _uid: nextExtraConsentItemUid(),
                      key: item?.key || '',
                      label: item?.label || '',
                      content: item?.content || '',
                      required: item?.required !== false
                  }))
                : [];
            extraConsentExpandedKey.value = undefined;

            // 處理 point_discounts：確保是陣列格式
            if (
                !productForm.value.point_discounts ||
                !Array.isArray(productForm.value.point_discounts)
            ) {
                productForm.value.point_discounts = [];
            } else {
                // 確保每個項目都有正確的結構，並過濾掉空項目
                productForm.value.point_discounts =
                    productForm.value.point_discounts
                        .map((discount) => {
                            // 處理 point_type：如果是物件，提取 id；如果是數字，直接使用；否則為 null
                            let pointTypeId = null;
                            if (discount.point_type) {
                                if (
                                    typeof discount.point_type === 'object' &&
                                    discount.point_type.id
                                ) {
                                    // 如果是物件，提取 id
                                    pointTypeId = discount.point_type.id;
                                } else if (
                                    typeof discount.point_type === 'number'
                                ) {
                                    // 如果已經是數字，直接使用
                                    pointTypeId = discount.point_type;
                                }
                            }

                            return {
                                point_type: pointTypeId,
                                mode:
                                    discount.mode !== undefined &&
                                    discount.mode !== null
                                        ? discount.mode
                                        : null,
                                value:
                                    discount.value !== undefined &&
                                    discount.value !== null
                                        ? discount.value
                                        : null
                            };
                        })
                        .filter((discount) => {
                            // 過濾掉完全為空的項目
                            return (
                                discount.point_type !== null ||
                                discount.mode !== null ||
                                discount.value !== null
                            );
                        });
            }

            // 處理 visibility_rules：確保是陣列格式
            if (
                !productForm.value.visibility_rules ||
                !Array.isArray(productForm.value.visibility_rules)
            ) {
                productForm.value.visibility_rules = [];
            } else {
                // 按 audience_type 分組，合併相同類型的規則
                const groupedRules = {};
                productForm.value.visibility_rules.forEach((rule) => {
                    if (!rule.audience_type) return;

                    const type = rule.audience_type;
                    if (!groupedRules[type]) {
                        groupedRules[type] = [];
                    }

                    // 轉換 audience_ref 為正確的類型
                    let audienceRef = rule.audience_ref;
                    if (type === 'role') {
                        // role 類型：保持字串
                        groupedRules[type].push(String(audienceRef));
                    } else if (type === 'rank' || type === 'department') {
                        // rank 和 department 類型：轉換為數字 id
                        const id = Number(audienceRef);
                        if (!isNaN(id)) {
                            groupedRules[type].push(id);
                        }
                    } else if (type === 'user') {
                        // user 類型：保持原值
                        const userId = Number(audienceRef);
                        if (!isNaN(userId)) {
                            groupedRules[type].push(userId);
                        }
                    }
                });

                // 轉換為表單格式
                productForm.value.visibility_rules = Object.keys(
                    groupedRules
                ).map((type) => ({
                    audience_type: type,
                    audience_ref: groupedRules[type]
                }));
            }

            // 處理 purchasable_rules：確保是陣列格式
            if (
                !productForm.value.purchasable_rules ||
                !Array.isArray(productForm.value.purchasable_rules)
            ) {
                productForm.value.purchasable_rules = [];
            } else {
                // 按 audience_type 分組，合併相同類型的規則
                const groupedRules = {};
                productForm.value.purchasable_rules.forEach((rule) => {
                    if (!rule.audience_type) return;

                    const type = rule.audience_type;
                    if (!groupedRules[type]) {
                        groupedRules[type] = [];
                    }

                    // 轉換 audience_ref 為正確的類型
                    let audienceRef = rule.audience_ref;
                    if (type === 'role') {
                        // role 類型：保持字串
                        groupedRules[type].push(String(audienceRef));
                    } else if (type === 'rank' || type === 'department') {
                        // rank 和 department 類型：轉換為數字 id
                        const id = Number(audienceRef);
                        if (!isNaN(id)) {
                            groupedRules[type].push(id);
                        }
                    } else if (type === 'user') {
                        // user 類型：保持原值
                        const userId = Number(audienceRef);
                        if (!isNaN(userId)) {
                            groupedRules[type].push(userId);
                        }
                    }
                });

                // 轉換為表單格式
                productForm.value.purchasable_rules = Object.keys(
                    groupedRules
                ).map((type) => ({
                    audience_type: type,
                    audience_ref: groupedRules[type]
                }));
            }

            // 處理商品支付方式：API 回傳 payment_methods，表單使用 product_payment_methods
            if (
                productForm.value.product_payment_methods &&
                Array.isArray(productForm.value.product_payment_methods) &&
                productForm.value.product_payment_methods.length > 0
            ) {
                productForm.value.product_payment_methods =
                    productForm.value.product_payment_methods.map((pm) => ({
                        payment_method_id:
                            typeof pm.payment_method_id === 'object' &&
                            pm.payment_method_id?.id != null
                                ? pm.payment_method_id.id
                                : pm.payment_method_id,
                        name: pm.name ?? '',
                        installment:
                            pm.installment !== undefined &&
                            pm.installment !== null
                                ? Number(pm.installment)
                                : 0,
                        price:
                            pm.price !== undefined && pm.price !== null
                                ? Number(pm.price)
                                : undefined
                    }));
            } else if (
                productForm.value.payment_methods &&
                Array.isArray(productForm.value.payment_methods)
            ) {
                productForm.value.product_payment_methods =
                    productForm.value.payment_methods.map((p) => ({
                        payment_method_id: p.id,
                        name: p.name ?? '',
                        installment: 0,
                        price: undefined
                    }));
            } else {
                productForm.value.product_payment_methods = [];
            }

            open.value = true;
        } else {
            showErrorMessage(response.message || '獲取商品資料失敗');
        }
    } catch (error) {
        console.error('獲取商品資料失敗:', error);
        showErrorMessage('獲取商品資料失敗');
    }
};

// 支援由 URL query editId 自動開啟編輯視窗（例如從物品管理頁以 iframe 嵌入）
watch(
    () => route.query.editId,
    (editId) => {
        if (editId && canEdit.value) {
            goEdit({ id: Number(editId) });
        }
    },
    { immediate: true }
);

// 關閉編輯視窗時清除 URL 的 editId，避免重開
watch(open, (val, prev) => {
    if (prev === true && val === false && route.query.editId) {
        const q = { ...route.query };
        delete q.editId;
        router.replace({ path: route.path, query: q });
    }
});

// 查看商品詳情
const viewModalVisible = ref(false);
const productDetail = ref(null);
const detailLoading = ref(false);

const handleCardClick = async (product) => {
    // 權限檢查
    if (!canView.value) {
        message.warning('您沒有查看商品詳情的權限');
        return;
    }

    try {
        detailLoading.value = true;
        // 調用 GET API 獲取最新資料
        const response = await getShopProduct(product.id);

        if (response.result && response.data) {
            resetInventoryThumbErrors();
            productDetail.value = response.data;
            viewModalVisible.value = true;
        } else {
            showErrorMessage(response.message || '獲取商品資料失敗');
        }
    } catch (error) {
        console.error('獲取商品資料失敗:', error);
        showErrorMessage('獲取商品資料失敗');
    } finally {
        detailLoading.value = false;
    }
};

// 支援由 URL query viewId 自動開啟「查看」詳情（非編輯）
watch(
    () => route.query.viewId,
    (viewId) => {
        if (viewId && canView.value) {
            handleCardClick({ id: Number(viewId) });
        }
    },
    { immediate: true }
);

watch(viewModalVisible, (val, prev) => {
    if (prev === true && val === false && route.query.viewId) {
        const q = { ...route.query };
        delete q.viewId;
        router.replace({ path: route.path, query: q });
    }
});

// 查看商品詳情 — 物品顯示輔助函式
const detailItemTypeColor = (type) =>
    ({ virtual: 'default', ticket: 'blue', physical: 'green' })[type] ??
    'default';
const detailItemTypeLabel = (type) =>
    ({ virtual: '一般道具', ticket: '票券', physical: '實體' })[type] ?? type;
const detailRarityColor = (rarity) =>
    ({
        white: 'default',
        green: 'success',
        blue: 'blue',
        purple: 'purple',
        orange: 'orange',
        red: 'error',
        gold: 'gold'
    })[rarity] ?? 'default';
const detailRarityLabel = (rarity) =>
    ({
        white: '普通',
        green: '優秀',
        blue: '稀有',
        purple: '史詩',
        orange: '傳說',
        red: '神話',
        gold: '唯一'
    })[rarity] ?? rarity;

const openAddModel = async () => {
    // 權限檢查
    if (!canCreate.value) {
        showErrorMessage('您沒有新增商品的權限');
        return;
    }

    await loadVendors();
    handleFormReset();
    open.value = true;
};

// 獲取點數類型名稱
const getPointTypeName = (pointTypeId) => {
    if (!pointTypes.value || pointTypes.value.length === 0) {
        return pointTypeId || '-';
    }
    const pointType = pointTypes.value.find((pt) => pt.id === pointTypeId);
    return pointType ? pointType.name : pointTypeId || '-';
};

const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

// 壓縮圖片
const compressImage = (
    file,
    maxWidth = 1920,
    maxHeight = 1920,
    quality = 0.75
) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;
                const originalSize = file.size;

                // 計算縮放比例
                if (width > maxWidth || height > maxHeight) {
                    const ratio = Math.min(
                        maxWidth / width,
                        maxHeight / height
                    );
                    width = width * ratio;
                    height = height * ratio;
                }

                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext('2d');
                // 提高圖片渲染品質
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
                ctx.drawImage(img, 0, 0, width, height);

                // 根據檔案類型選擇最佳格式和品質
                let outputType = file.type;
                let outputQuality = quality;

                // 對於 PNG，如果檔案很大，考慮轉換為 JPEG
                if (file.type === 'image/png' && originalSize > 500 * 1024) {
                    outputType = 'image/jpeg';
                    outputQuality = 0.8;
                }

                // 轉換為 Blob
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            // 檢查壓縮後的檔案大小
                            // 如果壓縮後比原始檔案大，使用原始檔案
                            if (blob.size >= originalSize) {
                                console.log(
                                    `壓縮後檔案變大（${(blob.size / 1024).toFixed(2)}KB >= ${(originalSize / 1024).toFixed(2)}KB），使用原始檔案`
                                );
                                resolve(file);
                                return;
                            }

                            // 創建新的 File 對象
                            const compressedFile = new File([blob], file.name, {
                                type: outputType,
                                lastModified: Date.now()
                            });
                            resolve(compressedFile);
                        } else {
                            resolve(file);
                        }
                    },
                    outputType,
                    outputQuality
                );
            };
            img.onerror = () => {
                reject(new Error('圖片載入失敗'));
            };
        };
        reader.onerror = () => {
            reject(new Error('檔案讀取失敗'));
        };
    });
};

// 驗證圖片檔案
const validateImageFile = (file) => {
    const maxSize = 2 * 1024 * 1024; // 2MB
    const allowedTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp'
    ];

    // 檢查檔案大小
    if (file.size > maxSize) {
        const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
        return {
            valid: false,
            message: `圖片大小（${fileSizeMB}MB）超過 2MB 限制，請先壓縮圖片後再上傳`,
            suggestions: [
                '使用圖片壓縮工具（如 TinyPNG、Squoosh）',
                '調整圖片尺寸（建議寬度 1920px 以內）',
                '降低圖片品質（建議 80-85%）',
                '轉換為更高效的格式（如 WebP）'
            ]
        };
    }

    // 檢查檔案類型
    if (!allowedTypes.includes(file.type)) {
        return {
            valid: false,
            message: '不支援的圖片格式，請使用 JPG、PNG、GIF 或 WebP'
        };
    }

    return { valid: true };
};

// 上傳前驗證
const handleBeforeUpload = (file) => {
    const validation = validateImageFile(file);
    if (!validation.valid) {
        // 顯示主要錯誤訊息
        showErrorMessage(validation.message);

        // 如果有建議，顯示詳細建議
        if (validation.suggestions && validation.suggestions.length > 0) {
            setTimeout(() => {
                const suggestionsList = validation.suggestions.map((s) =>
                    h(
                        'div',
                        { style: 'margin: 4px 0; line-height: 1.6;' },
                        `• ${s}`
                    )
                );
                message.warning({
                    content: h('div', [
                        h(
                            'div',
                            {
                                style: 'margin-bottom: 8px; font-weight: 600; color: #2a2a3a;'
                            },
                            '建議：'
                        ),
                        h(
                            'div',
                            {
                                style: 'line-height: 1.8; color: #6a6a7a; font-size: 13px;'
                            },
                            suggestionsList
                        )
                    ]),
                    duration: 10
                });
            }, 500);
        }

        return false;
    }

    // 阻止自動上傳，我們會在 handleImgChange 中處理
    return false;
};

const handleImgChange = async (info) => {
    console.log('handleImgChange called', info);

    // 獲取檔案：優先使用 originFileObj，如果沒有則使用 file 本身
    let originalFile = null;

    if (info.file) {
        // 當 before-upload 返回 false 時，檔案可能沒有 originFileObj，直接使用 file
        originalFile = info.file.originFileObj || info.file;
    }

    if (!originalFile) {
        console.warn('handleImgChange: 沒有找到有效的檔案', info);
        return;
    }

    console.log('原始檔案:', originalFile);

    // 標記圖片已改變
    productForm.value.cover_image_changed = true;
    productForm.value.imageError = false;
    productForm.value.cover_image_url = null;

    // 先立即保存原始檔案並顯示預覽（確保用戶能立即看到）
    productForm.value['cover_image'] = originalFile;
    getBase64(originalFile, (base64Url) => {
        console.log('預覽 URL 已設置');
        imagePreviewUrl.value = base64Url;
    });

    // 檢查檔案大小，如果超過 1MB 進行壓縮（建議最佳體驗）
    const fileSizeMB = originalFile.size / 1024 / 1024;
    const needsCompression = fileSizeMB > 1;

    if (needsCompression) {
        message.loading('圖片大小超過 1MB，正在壓縮...', 0);
        try {
            // 壓縮圖片
            const compressedFile = await compressImage(originalFile);
            const originalSizeKB = (originalFile.size / 1024).toFixed(2);
            const compressedSizeKB = (compressedFile.size / 1024).toFixed(2);
            const compressionRatio = (
                ((originalFile.size - compressedFile.size) /
                    originalFile.size) *
                100
            ).toFixed(1);
            console.log(
                `壓縮完成：${originalSizeKB}KB -> ${compressedSizeKB}KB (減少 ${compressionRatio}%)`
            );
            message.destroy(); // 關閉 loading

            // 檢查是否真的壓縮了
            if (compressedFile.size < originalFile.size) {
                message.success(
                    `圖片已壓縮：${originalSizeKB}KB → ${compressedSizeKB}KB (減少 ${compressionRatio}%)`
                );
            } else {
                message.info('圖片已優化，檔案大小未變');
            }

            // 更新 file list 中的文件
            if (info.fileList && info.fileList.length > 0) {
                // 如果原本有 originFileObj，更新它；否則創建一個新的屬性
                if (info.fileList[0].originFileObj !== undefined) {
                    info.fileList[0].originFileObj = compressedFile;
                } else {
                    // 創建一個新的 File 對象來替換
                    Object.assign(info.fileList[0], {
                        originFileObj: compressedFile
                    });
                }
            }

            // 保存壓縮後的檔案到 productForm
            productForm.value['cover_image'] = compressedFile;

            // 更新預覽
            getBase64(compressedFile, (base64Url) => {
                imagePreviewUrl.value = base64Url;
            });
        } catch (error) {
            console.error('圖片壓縮失敗:', error);
            message.destroy(); // 關閉 loading
            message.warning('圖片壓縮失敗，使用原始圖片');
            // 保持原始檔案
            productForm.value['cover_image'] = originalFile;
        }
    } else {
        // 如果檔案不大，檢查圖片尺寸，如果過大也進行壓縮
        const img = new Image();
        const objectUrl = URL.createObjectURL(originalFile);
        img.onload = async () => {
            URL.revokeObjectURL(objectUrl);
            if (img.width > 1920 || img.height > 1920) {
                try {
                    message.loading('圖片尺寸過大，正在壓縮...', 0);
                    const compressedFile = await compressImage(originalFile);
                    message.destroy();
                    message.success('圖片已優化');
                    if (info.fileList && info.fileList.length > 0) {
                        if (info.fileList[0].originFileObj !== undefined) {
                            info.fileList[0].originFileObj = compressedFile;
                        } else {
                            Object.assign(info.fileList[0], {
                                originFileObj: compressedFile
                            });
                        }
                    }
                    // 保存壓縮後的檔案
                    productForm.value['cover_image'] = compressedFile;
                    getBase64(compressedFile, (base64Url) => {
                        imagePreviewUrl.value = base64Url;
                    });
                } catch (error) {
                    console.error('圖片壓縮失敗:', error);
                    message.destroy();
                    message.warning('圖片壓縮失敗，使用原始圖片');
                    // 保持原始檔案
                    productForm.value['cover_image'] = originalFile;
                }
            }
            // 如果不需要壓縮，檔案已經在之前保存了
        };
        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            console.error('圖片載入失敗');
        };
        img.src = objectUrl;
    }
};

const handleImgRemove = (info) => {
    if (info && info.originFileObj) {
        info.originFileObj = null;
    }
    imagePreviewUrl.value = null;
    productForm.value.cover_image_url = null;
    productForm.value.preview_cover_image = [];
};

const handleRemoveImage = () => {
    imagePreviewUrl.value = null;
    productForm.value.cover_image_url = null;
    productForm.value.preview_cover_image = [];
    productForm.value.cover_image = null;
    // 標記圖片已被刪除，用於提交時告知後端
    productForm.value.imageError = true;
    productForm.value.cover_image_changed = true;
};

const addDiscount = () => {
    productForm.value.point_discounts.push({
        point_type: null,
        mode: null,
        value: null
    });
};

const removeDiscount = (idx) => {
    productForm.value.point_discounts.splice(idx, 1);
};

const addProductPaymentMethod = () => {
    const defaultPrice =
        productForm.value.price !== null &&
        productForm.value.price !== undefined &&
        productForm.value.price !== ''
            ? Number(productForm.value.price)
            : undefined;
    productForm.value.product_payment_methods.push({
        payment_method_id: undefined,
        name: '',
        installment: 0,
        price: defaultPrice
    });
};

const removeProductPaymentMethod = (idx) => {
    productForm.value.product_payment_methods.splice(idx, 1);
};

// 監聽商品類型變化，自動設定是否需要寄送
watch(
    () => productForm.value.type,
    (newType) => {
        // 只有在新增模式（沒有id）且requires_shipping為null時才自動設定
        if (
            !productForm.value.id &&
            productForm.value.requires_shipping === null
        ) {
            if (newType === 'physical') {
                // 實體商品預設需要寄送
                productForm.value.requires_shipping = 1;
            } else if (
                newType === 'virtual' ||
                newType === 'course' ||
                newType === 'ticket'
            ) {
                // 虛擬、課程、票卷預設不需要寄送
                productForm.value.requires_shipping = 0;
            }
        }
    }
);

// 背包 API 暫時不呼叫
// const loadInventoryItemTypes = async () => {
//     try {
//         const response = await getInventoryItemTypes();
//         if (response.result && Array.isArray(response.data)) {
//             inventoryItemTypeOptions.value = response.data.map((item) => ({
//                 label: item.display_name,
//                 value: item.id
//             }));
//         }
//     } catch {
//         inventoryItemTypeOptions.value = [];
//     }
// };

const loadVendors = async () => {
    try {
        const response = await listVendors();
        if (response?.result) {
            vendors.value = Array.isArray(response.data) ? response.data : [];
        }
    } catch {
        showErrorMessage('載入廠商失敗');
    }
};

onMounted(() => {
    loadProducts();
    loadCategories();
    loadVendors();
    loadPointTypes();
    loadPaymentMethods();
    loadProductOptions();
    loadPurchaseRequirementOptions();
    // loadInventoryItemTypes();
});
</script>

<style scoped>
.product-list-page {
    padding: 24px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    min-height: 100vh;
}

.page-header {
    margin-bottom: 24px;
}

.page-header h1 {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
}

.page-header p {
    margin: 0;
    color: #6a6a7a;
    font-size: 14px;
    font-family: 'Courier New', monospace;
}

.content {
    background: #ffffff;
    border: 1px solid rgba(138, 175, 255, 0.15);
    border-radius: 12px;
    padding: 24px;
    min-height: 400px;
    position: relative;
    box-shadow: 0 2px 12px rgba(138, 175, 255, 0.08);
}

.toolbar {
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
}

/* 篩選器區域 */
.filters-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(168, 255, 246, 0.2);
}

/* 搜尋區域 */
.search-section {
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;
}

.search-wrapper {
    flex: 1;
    max-width: 500px;
}

.search-input {
    width: 100%;
    font-family: 'Courier New', monospace;
}

/* 搜尋框邊框樣式見 @/styles/page-layout.css（search-input） */

.search-input :deep(.ant-input::placeholder) {
    color: rgba(42, 42, 58, 0.5) !important;
    font-family: 'Courier New', monospace !important;
}

/* 類型與狀態標籤行 */
.filter-tags-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 8px;
}

/* 分類標籤篩選 */
.filter-tags-section {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(138, 175, 255, 0.2);
    border-radius: 8px;
    margin-bottom: 0;
    flex: 1;
    min-width: 200px;
}

.filter-tags-section .filter-label {
    font-size: 13px;
    color: #6a6a7a;
    font-weight: 600;
    font-family: 'Courier New', monospace;
    white-space: nowrap;
}

.filter-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-start;
    width: 100%;
}

.filter-tag {
    margin: 0 !important;
    padding: 4px 12px !important;
    border-radius: 6px !important;
    font-family: 'Courier New', monospace !important;
    font-size: 12px !important;
    cursor: pointer;
    transition: all 0.2s ease !important;
    background: rgba(255, 255, 255, 0.8) !important;
    border: 1px solid rgba(138, 175, 255, 0.3) !important;
    color: #2a2a3a !important;
}

.filter-tag:hover {
    background: rgba(138, 175, 255, 0.15) !important;
    border-color: rgba(42, 74, 122, 0.5) !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(42, 74, 122, 0.2) !important;
}

.filter-tag-active {
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5) !important;
    border-color: #2a4a7a !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.3) !important;
}

.filter-tag-active:hover {
    background: linear-gradient(135deg, #3b6ea5, #2a4a7a) !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.4) !important;
}

/* 子分類行 */
.category-children-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid rgba(42, 74, 122, 0.2);
    width: 100%;
    clear: both;
}

/* 大分類標籤 */
.filter-tag-parent {
    margin-bottom: 0;
    position: relative;
}

/* 展開/收合圖示 */
.expand-icon {
    display: inline-block;
    margin-right: 6px;
    cursor: pointer;
    font-size: 10px;
    color: rgba(42, 74, 122, 0.8);
    transition: transform 0.2s ease;
    user-select: none;
    padding: 2px 4px;
    border-radius: 3px;
}

.expand-icon:hover {
    color: #2a4a7a;
    background: rgba(42, 74, 122, 0.1);
}

/* 分類項目容器 */
.category-item-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
}

/* 子分類容器 */
.category-children-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-left: 20px;
    padding-left: 12px;
    border-left: 2px solid rgba(42, 74, 122, 0.3);
}

/* 子分類標籤樣式 */
.filter-tag-child {
    font-size: 11px !important;
    opacity: 0.85 !important;
}

.filter-tag-child:hover {
    opacity: 1 !important;
}

/* 商品數量標籤 */
.category-count {
    font-size: 11px;
    font-weight: 600;
    color: rgba(42, 42, 58, 0.6);
    margin-left: 4px;
}

.filter-tag-active .category-count {
    color: rgba(255, 255, 255, 0.9);
}

.filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-end;
}

.filter-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.filter-label {
    font-size: 13px;
    color: #6a6a7a;
    font-weight: 500;
    font-family: 'Courier New', monospace;
}

.filter-select {
    width: 140px;
}

.filter-select :deep(.ant-select-selector) {
    border-radius: 6px !important;
    border-color: rgba(138, 175, 255, 0.3) !important;
    transition: all 0.2s ease !important;
}

.filter-select :deep(.ant-select-selector:hover) {
    border-color: rgba(42, 74, 122, 0.5) !important;
}

.filter-select :deep(.ant-select-focused .ant-select-selector) {
    border-color: #3b6ea5 !important;
    box-shadow: 0 0 0 2px rgba(138, 175, 255, 0.1) !important;
}

.filter-item.price-range {
    width: auto;
}

.price-inputs {
    display: flex;
    align-items: center;
    gap: 8px;
}

.price-input {
    width: 100px;
}

.price-input :deep(.ant-input-number-input) {
    border-radius: 6px !important;
    border-color: rgba(138, 175, 255, 0.3) !important;
    font-family: 'Courier New', monospace !important;
}

.price-input :deep(.ant-input-number:hover) {
    border-color: rgba(42, 74, 122, 0.5) !important;
}

.price-input :deep(.ant-input-number-focused) {
    border-color: #3b6ea5 !important;
    box-shadow: 0 0 0 2px rgba(138, 175, 255, 0.1) !important;
}

.price-separator {
    color: #3b6ea5;
    font-weight: 600;
    font-size: 14px;
}

.filter-item.checkbox-item {
    justify-content: flex-end;
    padding-bottom: 4px;
}

.filter-item.checkbox-item :deep(.ant-checkbox-wrapper) {
    font-size: 13px;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
}

.filter-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    flex-shrink: 0;
    margin-left: auto;
}

/* 兩行顯示單元格樣式 */
:deep(.two-line-cell) {
    display: flex !important;
    flex-direction: column !important;
    gap: 3px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    min-height: 40px !important;
    justify-content: center !important;
}

:deep(.cell-line) {
    display: flex !important;
    align-items: center !important;
    white-space: nowrap !important;
    font-size: 12px !important;
}

.two-line-cell {
    display: flex !important;
    flex-direction: column !important;
    gap: 3px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    min-height: 40px !important;
    justify-content: center !important;
}

.cell-line {
    display: flex !important;
    align-items: center !important;
    white-space: nowrap !important;
    font-size: 12px !important;
}

.cell-label {
    font-weight: 600;
    color: rgba(42, 42, 58, 0.7);
    margin-right: 4px;
    font-size: 11px;
    min-width: 36px;
}

/* 操作欄位樣式 */
.actions-space {
    display: flex !important;
    flex-wrap: nowrap !important;
    white-space: nowrap !important;
    gap: 8px !important;
}

.actions-space :deep(.ant-btn-link) {
    padding: 0 8px !important;
    font-size: 13px !important;
    height: auto !important;
    line-height: 1.5 !important;
    color: #3b6ea5 !important;
    font-family: 'Courier New', monospace !important;
    font-weight: 500 !important;
    transition: all 0.2s ease !important;
}

.actions-space :deep(.ant-btn-link:hover) {
    color: #2a4a7a !important;
}

.actions-space :deep(.ant-btn-link:last-child) {
    color: #ff6b6b !important;
}

.actions-space :deep(.ant-btn-link:last-child:hover) {
    color: #ff4d4f !important;
}

/* 確保表格單元格內的字體大小 */
:deep(.ant-table-cell .two-line-cell),
:deep(.ant-table-tbody .two-line-cell) {
    font-size: 12px !important;
}

:deep(.ant-table-cell .cell-line),
:deep(.ant-table-tbody .cell-line) {
    font-size: 12px !important;
}

/* 確保固定欄位正確顯示 */
:deep(.ant-table-cell-fix-right) {
    background: #fff !important;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.05) !important;
}

:deep(.ant-table-cell-fix-right-first::after) {
    box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.08) !important;
}

/* 移除固定欄位與前一欄位的間隔 */
:deep(.ant-table-cell-fix-right-first) {
    border-left: none !important;
}

:deep(.ant-table-cell) {
    padding: 12px 16px !important;
}

:deep(.ant-table-thead > tr > th) {
    background: rgba(138, 175, 255, 0.05) !important;
    border-bottom: 2px solid rgba(138, 175, 255, 0.15) !important;
    font-weight: 600 !important;
    color: #2a2a3a !important;
    font-family: 'Courier New', monospace !important;
    font-size: 13px !important;
}

:deep(.ant-table-tbody > tr:hover > td) {
    background: rgba(42, 74, 122, 0.03) !important;
}

:deep(.ant-table-tbody > tr > td) {
    border-bottom: 1px solid rgba(138, 175, 255, 0.1) !important;
}

/* 當表格不需要橫向滾動時，移除固定欄位的間隔 */
:deep(.ant-table-body) {
    overflow-x: auto !important;
}

:deep(.ant-table-container) {
    overflow-x: auto !important;
}

/* DataTable component integration - 與會員列表統一 */
:deep(.ant-card) {
    background: transparent !important;
    border: none !important;
}

:deep(.ant-card-body) {
    padding: 0 !important;
}

/* 主要按鈕樣式（新增） */
:deep(.add_btn) {
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5) !important;
    border: none !important;
    color: #ffffff !important;
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    border-radius: 8px !important;
    padding: 8px 20px !important;
    height: 40px !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.3) !important;
    transition: all 0.2s ease !important;
    white-space: nowrap !important;
}

:deep(.add_btn:hover) {
    background: linear-gradient(135deg, #3b6ea5, #2a4a7a) !important;
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.4) !important;
    transform: translateY(-1px) !important;
}

/* 次要按鈕樣式（查詢、重置） */
:deep(.function-btn) {
    background: #ffffff !important;
    border: 1.5px solid rgba(138, 175, 255, 0.3) !important;
    color: #2a2a3a !important;
    font-family: 'Courier New', monospace !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    border-radius: 8px !important;
    padding: 6px 16px !important;
    height: 36px !important;
    transition: all 0.2s ease !important;
}

:deep(.function-btn:hover) {
    background: rgba(138, 175, 255, 0.08) !important;
    border-color: rgba(42, 74, 122, 0.5) !important;
    color: #2a2a3a !important;
    transform: translateY(-1px) !important;
}

:deep(.reset-btn) {
    border-color: rgba(255, 158, 207, 0.3) !important;
}

:deep(.reset-btn:hover) {
    background: rgba(255, 158, 207, 0.08) !important;
    border-color: rgba(255, 158, 207, 0.5) !important;
}

/* 其他按鈕樣式 */
:deep(.ant-btn) {
    font-family: 'Courier New', monospace !important;
}

:deep(.ant-btn .anticon) {
    color: inherit !important;
}

/* 商品圖片樣式 */
.product-image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.product-image {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 8px;
    border: 1.5px solid rgba(138, 175, 255, 0.2);
    transition: all 0.2s ease;
    background: #f8f9fa;
}

.product-image:hover {
    border-color: rgba(42, 74, 122, 0.5);
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.2);
    transform: scale(1.02);
}

.product-image-placeholder {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    background: linear-gradient(
        135deg,
        rgba(138, 175, 255, 0.1),
        rgba(42, 74, 122, 0.1)
    );
    border: 1.5px dashed rgba(138, 175, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: #3b6ea5;
    font-family: 'Courier New', monospace;
}

/* 商品名稱單元格樣式 */
.product-name-cell {
    display: flex;
    flex-direction: column;
    gap: 6px;
    text-align: left;
    padding: 4px 0;
}

.product-name-cell .name {
    font-weight: 600;
    color: #2a2a3a;
    font-size: 14px;
    line-height: 1.5;
    font-family: 'Courier New', monospace;
}

.product-name-cell .subtitle {
    font-size: 12px;
    color: #3b6ea5;
    line-height: 1.4;
    font-family: 'Courier New', monospace;
    font-weight: 400;
}

/* 庫存數量樣式 */
.stock-low {
    color: #ffa87a;
    font-weight: 600;
    font-size: 14px;
}

.stock-out {
    color: #ff6b6b;
    font-weight: 600;
    font-size: 14px;
}

/* 狀態標籤樣式 */
.status-draft {
    background: rgba(138, 175, 255, 0.15) !important;
    color: #3b6ea5 !important;
    border: 1px solid rgba(138, 175, 255, 0.3) !important;
    font-weight: 500 !important;
}

.status-active {
    background: rgba(208, 255, 183, 0.2) !important;
    color: #52c41a !important;
    border: 1px solid rgba(208, 255, 183, 0.4) !important;
    font-weight: 500 !important;
}

.status-inactive {
    background: rgba(255, 168, 122, 0.15) !important;
    color: #ffa87a !important;
    border: 1px solid rgba(255, 168, 122, 0.3) !important;
    font-weight: 500 !important;
}

/* 可購買標籤樣式 */
.tag-purchasable {
    background: rgba(208, 255, 183, 0.2) !important;
    color: #52c41a !important;
    border: 1px solid rgba(208, 255, 183, 0.4) !important;
    font-weight: 500 !important;
}

.tag-unpurchasable {
    background: rgba(255, 255, 255, 0.6) !important;
    color: #8c8c8c !important;
    border: 1px solid rgba(140, 140, 140, 0.2) !important;
    font-weight: 500 !important;
}

/* 價格顯示樣式 */
.price-value {
    font-weight: 600;
    color: #2a2a3a;
    font-size: 14px;
    font-family: 'Courier New', monospace;
}

/* 商品卡片視圖樣式 */
.products-card-view {
    margin-top: 16px;
}

.products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.product-card {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(42, 74, 122, 0.3);
    border-radius: 12px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 不同狀態的卡片樣式 */
.product-card-draft {
    background: rgba(255, 255, 255, 0.7);
    border: 1.5px solid rgba(138, 175, 255, 0.4);
    opacity: 0.85;
    padding-top: 28px;
    /* 為狀態提示條留出空間 */
}

.product-card-draft::before {
    background: linear-gradient(
        135deg,
        rgba(138, 175, 255, 0.08),
        rgba(42, 74, 122, 0.08)
    );
}

.product-card-active {
    background: rgba(255, 255, 255, 0.95);
    border: 1.5px solid rgba(208, 255, 183, 0.5);
    box-shadow: 0 2px 8px rgba(208, 255, 183, 0.15);
    padding-top: 28px;
    /* 為狀態提示條留出空間 */
}

.product-card-active::before {
    background: linear-gradient(
        135deg,
        rgba(208, 255, 183, 0.1),
        rgba(168, 255, 246, 0.1)
    );
}

.product-card-inactive {
    background: rgba(255, 255, 255, 0.75);
    border: 1.5px solid rgba(255, 168, 122, 0.4);
    opacity: 0.9;
    padding-top: 28px;
    /* 為狀態提示條留出空間 */
}

.product-card-inactive::before {
    background: linear-gradient(
        135deg,
        rgba(255, 168, 122, 0.08),
        rgba(255, 158, 207, 0.08)
    );
}

.product-card-scheduled {
    background: rgba(255, 255, 255, 0.85);
    border: 1.5px solid rgba(42, 74, 122, 0.4);
    opacity: 0.9;
    padding-top: 28px;
    /* 為狀態提示條留出空間 */
}

.product-card-scheduled::before {
    background: linear-gradient(
        135deg,
        rgba(42, 74, 122, 0.08),
        rgba(138, 175, 255, 0.08)
    );
}

.product-card-expired {
    background: rgba(255, 255, 255, 0.7);
    border: 1.5px solid rgba(255, 107, 107, 0.4);
    opacity: 0.85;
    padding-top: 28px;
    /* 為狀態提示條留出空間 */
}

.product-card-expired::before {
    background: linear-gradient(
        135deg,
        rgba(255, 107, 107, 0.08),
        rgba(255, 168, 122, 0.08)
    );
}

/* 狀態提示條 */
.product-status-banner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    font-family: 'Courier New', monospace;
    text-align: center;
    z-index: 5;
    backdrop-filter: blur(4px);
    border-radius: 12px 12px 0 0;
}

.status-banner-draft {
    background: linear-gradient(
        90deg,
        rgba(138, 175, 255, 0.3),
        rgba(42, 74, 122, 0.3)
    );
    color: #3b6ea5;
    border-bottom: 1px solid rgba(138, 175, 255, 0.3);
}

.status-banner-active {
    background: linear-gradient(
        90deg,
        rgba(208, 255, 183, 0.4),
        rgba(168, 255, 246, 0.4)
    );
    color: #52c41a;
    border-bottom: 1px solid rgba(208, 255, 183, 0.4);
}

.status-banner-inactive {
    background: linear-gradient(
        90deg,
        rgba(255, 168, 122, 0.3),
        rgba(255, 158, 207, 0.3)
    );
    color: #ffa87a;
    border-bottom: 1px solid rgba(255, 168, 122, 0.3);
}

.status-banner-scheduled {
    background: linear-gradient(
        90deg,
        rgba(42, 74, 122, 0.3),
        rgba(138, 175, 255, 0.3)
    );
    color: #2a4a7a;
    border-bottom: 1px solid rgba(42, 74, 122, 0.3);
}

.status-banner-expired {
    background: linear-gradient(
        90deg,
        rgba(255, 107, 107, 0.3),
        rgba(255, 168, 122, 0.3)
    );
    color: #ff6b6b;
    border-bottom: 1px solid rgba(255, 107, 107, 0.3);
}

.status-banner-text {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.5px;
}

.product-card-actions {
    position: absolute;
    top: 32px;
    /* 調整位置，避免與狀態提示條重疊 */
    right: 8px;
    display: flex;
    gap: 4px;
    z-index: 10;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.product-card:hover .product-card-actions {
    opacity: 1;
}

.product-card-sort {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 12;
}

.product-card-sort :deep(.sort-stepper) {
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}

.product-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        135deg,
        rgba(255, 158, 207, 0.05),
        rgba(42, 74, 122, 0.05),
        rgba(138, 175, 255, 0.05)
    );
    opacity: 0;
    transition: opacity 0.3s ease;
}

.product-card:hover {
    transform: translateY(-5px);
    border-color: #2a4a7a;
    box-shadow:
        0 8px 25px rgba(42, 74, 122, 0.25),
        0 4px 20px rgba(168, 255, 246, 0.15);
}

.product-card:hover::before {
    opacity: 1;
}

.action-btn {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(42, 74, 122, 0.3) !important;
    border-radius: 6px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;
}

.action-btn:hover {
    background: rgba(255, 255, 255, 1) !important;
    border-color: #2a4a7a !important;
    transform: scale(1.1);
}

.edit-btn:hover {
    color: #3b6ea5 !important;
}

.delete-btn:hover {
    color: #ff6b6b !important;
}

.product-card-image {
    position: relative;
    width: 100%;
    height: 160px;
    margin-bottom: 10px;
    border-radius: 8px;
    overflow: hidden;
    background: linear-gradient(
        135deg,
        rgba(138, 175, 255, 0.1),
        rgba(42, 74, 122, 0.1)
    );
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    min-height: 160px;
}

/* 類型標籤（左上角） */
.product-type-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 10;
    pointer-events: none;
}

.product-type-badge :deep(.ant-tag) {
    margin: 0 !important;
    padding: 4px 10px !important;
    border-radius: 6px !important;
    font-family: 'Courier New', monospace !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
    backdrop-filter: blur(4px) !important;
}

/* 轉成背包標記（右下角，有背景） */
.product-inventory-badge {
    position: absolute;
    bottom: 8px;
    right: 8px;
    z-index: 10;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    pointer-events: none;
}

.product-inventory-badge .inventory-badge-icon {
    font-size: 16px;
    color: #fff;
}

/* 購買前要求（左下角）— 僅彩色圖示，無底色 */
.product-requirement-badge {
    position: absolute;
    bottom: 8px;
    left: 8px;
    z-index: 10;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    box-shadow: none;
    pointer-events: none;
}

.product-requirement-badge__icon {
    font-size: 18px;
    color: #69c0ff;
    filter: drop-shadow(0 1px 2px rgba(255, 255, 255, 0.85));
}

.product-requirement-badge--consent .product-requirement-badge__icon {
    color: #d48806;
}

.type-tag-physical {
    background: linear-gradient(135deg, #3b6ea5, #2a4a7a) !important;
    border: none !important;
    color: #ffffff !important;
}

.type-tag-virtual {
    background: linear-gradient(135deg, #0e7490, #3b6ea5) !important;
    border: none !important;
    color: #2a2a3a !important;
}

.type-tag-course {
    background: linear-gradient(135deg, #64748b, #ffa87a) !important;
    border: none !important;
    color: #ffffff !important;
}

.type-tag-ticket {
    background: linear-gradient(135deg, #d0ffb7, #0e7490) !important;
    border: none !important;
    color: #2a2a3a !important;
}

.type-tag-default {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(42, 74, 122, 0.3) !important;
    color: #2a2a3a !important;
}

.product-cover-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    display: block;
    transition: transform 0.3s ease;
}

.product-card:hover .product-cover-image {
    transform: scale(1.05);
}

.product-image-placeholder,
.product-image-error {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    color: #3b6ea5;
    background: linear-gradient(
        135deg,
        rgba(138, 175, 255, 0.08),
        rgba(42, 74, 122, 0.08)
    );
    border: 1.5px dashed rgba(138, 175, 255, 0.3);
    transition: all 0.3s ease;
}

.product-image-error {
    color: #ffa87a;
    background: linear-gradient(
        135deg,
        rgba(255, 168, 122, 0.08),
        rgba(255, 158, 207, 0.08)
    );
    border-color: rgba(255, 168, 122, 0.3);
}

.product-card:hover .product-image-placeholder,
.product-card:hover .product-image-error {
    border-color: rgba(42, 74, 122, 0.5);
    background: linear-gradient(
        135deg,
        rgba(138, 175, 255, 0.12),
        rgba(42, 74, 122, 0.12)
    );
}

/* 時間提醒（圖片下方中間） */
.product-time-reminder {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    backdrop-filter: blur(8px);
    color: #ffffff;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 11px;
    font-family: 'Courier New', monospace;
    font-weight: 500;
    white-space: nowrap;
    z-index: 5;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.15);
}

/* 即將上架 - 淡綠色主題 */
.time-reminder-upcoming {
    background: rgba(208, 255, 183, 0.5);
    border-color: rgba(208, 255, 183, 0.4);
    color: #2a2a3a;
}

/* 下架時間 - 橘色主題 */
.time-reminder-unpublish {
    background: rgba(255, 168, 122, 0.5);
    border-color: rgba(255, 168, 122, 0.4);
    color: #2a2a3a;
}

/* 已下架 - 灰色主題 */
.time-reminder-default {
    background: rgba(140, 140, 140, 0.55);
    border-color: rgba(140, 140, 140, 0.4);
    color: #ffffff;
}

.product-card-body {
    position: relative;
    z-index: 1;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.product-card-name {
    margin-bottom: 6px;
}

.product-name-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
}

.product-name {
    flex: 1;
    min-width: 0;
    font-weight: 600;
    color: #2a2a3a;
    font-size: 14px;
    line-height: 1.4;
    font-family: 'Courier New', monospace;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.product-subtitle {
    font-size: 12px;
    color: #3b6ea5;
    line-height: 1.4;
    font-family: 'Courier New', monospace;
    font-weight: 400;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.product-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 6px;
}

/* 商品卡片：支援支付方式（精簡一行，hover 顯示完整） */
.product-payment-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    font-size: 11px;
    color: #8a8a9a;
    font-family: 'Courier New', monospace;
    line-height: 1.3;
}

.payment-hint-icon {
    flex-shrink: 0;
    font-size: 12px;
    color: #3b6ea5;
}

.payment-hint-tags {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.payment-hint-name {
    color: #6a6a7a;
}

.payment-hint-sep {
    color: #9a9aaa;
}

.payment-hint-more {
    color: #2a4a7a;
    font-weight: 600;
}

/* 商品卡片：尚未設定支付方式之紅色提醒標籤 */
.payment-unset-tag {
    display: inline-flex !important;
    align-items: center !important;
    gap: 4px !important;
    background: rgba(255, 77, 79, 0.15) !important;
    color: #ff4d4f !important;
    border: 1px solid rgba(255, 77, 79, 0.4) !important;
    font-weight: 600 !important;
    font-size: 11px !important;
    font-family: 'Courier New', monospace !important;
}

.payment-unset-icon {
    font-size: 12px;
}

.product-card-price {
    margin-top: auto;
    padding-top: 10px;
    border-top: 1px solid rgba(42, 74, 122, 0.15);
    display: flex;
    align-items: center;
    gap: 6px;
}

.price-label {
    font-size: 12px;
    color: #6a6a7a;
    font-family: 'Courier New', monospace;
}

.price-value {
    font-weight: 700;
    color: #2a2a3a;
    font-size: 16px;
    font-family: 'Courier New', monospace;
    text-shadow: 0 0 8px rgba(42, 74, 122, 0.2);
}

/* 庫存標籤樣式 */
.stock-tag-normal {
    background: rgba(208, 255, 183, 0.2) !important;
    color: #52c41a !important;
    border: 1px solid rgba(208, 255, 183, 0.4) !important;
    font-weight: 500 !important;
}

.stock-tag-low {
    background: rgba(255, 168, 122, 0.2) !important;
    color: #ffa87a !important;
    border: 1px solid rgba(255, 168, 122, 0.4) !important;
    font-weight: 600 !important;
}

.stock-tag-unlimited {
    background: linear-gradient(
        135deg,
        rgba(42, 74, 122, 0.2),
        rgba(138, 175, 255, 0.2)
    ) !important;
    color: #2a4a7a !important;
    border: 1px solid rgba(42, 74, 122, 0.4) !important;
    font-weight: 600 !important;
}

.stock-tag-zero {
    background: rgba(255, 77, 79, 0.15) !important;
    color: #ff4d4f !important;
    border: 1px solid rgba(255, 77, 79, 0.3) !important;
    font-weight: 600 !important;
}

.unlimited-symbol {
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    display: inline-block;
}

/* 寄送標籤樣式 */
.shipping-tag-yes {
    background: rgba(138, 175, 255, 0.2) !important;
    color: #3b6ea5 !important;
    border: 1px solid rgba(138, 175, 255, 0.4) !important;
    font-weight: 500 !important;
}

.shipping-tag-no {
    background: rgba(140, 140, 140, 0.15) !important;
    color: #8c8c8c !important;
    border: 1px solid rgba(140, 140, 140, 0.3) !important;
    font-weight: 500 !important;
}

/* 限購數量標籤樣式 */
.max-qty-tag {
    background: rgba(138, 175, 255, 0.25) !important;
    color: #2a2a3a !important;
    border: 1px solid rgba(138, 175, 255, 0.5) !important;
    font-weight: 600 !important;
}

/* 上架時間狀態標籤樣式 */
.publish-status-inactive {
    background: rgba(255, 168, 122, 0.2) !important;
    color: #ffa87a !important;
    border: 1px solid rgba(255, 168, 122, 0.4) !important;
    font-weight: 500 !important;
}

.publish-status-upcoming {
    background: rgba(42, 74, 122, 0.2) !important;
    color: #2a4a7a !important;
    border: 1px solid rgba(42, 74, 122, 0.4) !important;
    font-weight: 500 !important;
}

.publish-status-scheduled {
    background: rgba(255, 158, 207, 0.2) !important;
    color: #64748b !important;
    border: 1px solid rgba(255, 158, 207, 0.4) !important;
    font-weight: 500 !important;
}

/* 不可購買原因標籤樣式 */
.unpurchasable-reason-inactive {
    background: rgba(255, 168, 122, 0.2) !important;
    color: #ffa87a !important;
    border: 1px solid rgba(255, 168, 122, 0.4) !important;
    font-weight: 600 !important;
}

.unpurchasable-reason-out-of-stock {
    background: rgba(255, 107, 107, 0.2) !important;
    color: #ff6b6b !important;
    border: 1px solid rgba(255, 107, 107, 0.4) !important;
    font-weight: 600 !important;
}

.unpurchasable-reason-time {
    background: rgba(255, 158, 207, 0.2) !important;
    color: #64748b !important;
    border: 1px solid rgba(255, 158, 207, 0.4) !important;
    font-weight: 500 !important;
}

.unpurchasable-reason-default {
    background: rgba(140, 140, 140, 0.2) !important;
    color: #8c8c8c !important;
    border: 1px solid rgba(140, 140, 140, 0.4) !important;
    font-weight: 500 !important;
}

.empty-products {
    text-align: center;
    padding: 60px 20px;
    color: #999;
    font-family: 'Courier New', monospace;
    font-style: italic;
}

.pagination-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    padding: 16px 0;
}

/* 分頁器蒸氣波淺色版樣式 - 參考 DataTable */
.pagination-wrapper :deep(.ant-pagination) {
    background: transparent !important;
    color: #2a2a3a !important;
}

/* 分頁按鈕 - 完全橢圓 */
.pagination-wrapper :deep(.ant-pagination-item) {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(200, 200, 210, 0.4) !important;
    color: #2a2a3a !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 50px !important;
    margin: 0 4px !important;
    min-width: 32px !important;
    height: 32px !important;
    line-height: 30px !important;
    text-align: center !important;
    transition: all 0.3s ease !important;
}

.pagination-wrapper :deep(.ant-pagination-item a) {
    color: #2a2a3a !important;
}

.pagination-wrapper :deep(.ant-pagination-item:hover a) {
    color: #2a4a7a !important;
}

.pagination-wrapper :deep(.ant-pagination-item:hover) {
    background: rgba(255, 255, 255, 0.95) !important;
    border-color: #2a4a7a !important;
    color: #2a4a7a !important;
    box-shadow: 0 0 8px rgba(42, 74, 122, 0.25) !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active) {
    background: linear-gradient(45deg, #2a4a7a, #3b6ea5) !important;
    border-color: #2a4a7a !important;
    color: #0d0d0d !important;
    box-shadow: 0 0 10px rgba(42, 74, 122, 0.35) !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
    color: #0d0d0d !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
    background: rgba(42, 74, 122, 0.4) !important;
    border-color: #2a4a7a !important;
    color: #2a4a7a !important;
    box-shadow: none !important;
}

/* 上一頁/下一頁按鈕 - 完全橢圓 */
.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next) {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(200, 200, 210, 0.4) !important;
    color: #2a2a3a !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 50px !important;
    margin: 0 4px !important;
    min-width: 32px !important;
    height: 32px !important;
    line-height: 30px !important;
    transition: all 0.3s ease !important;
}

.pagination-wrapper :deep(.ant-pagination-prev:hover),
.pagination-wrapper :deep(.ant-pagination-next:hover) {
    background: rgba(255, 255, 255, 0.95) !important;
    border-color: #2a4a7a !important;
    color: #2a4a7a !important;
    box-shadow: 0 0 8px rgba(42, 74, 122, 0.25) !important;
}

.pagination-wrapper :deep(.ant-pagination-prev .anticon),
.pagination-wrapper :deep(.ant-pagination-next .anticon) {
    color: #2a2a3a !important;
    transition: color 0.3s ease !important;
}

.pagination-wrapper :deep(.ant-pagination-prev:hover .anticon),
.pagination-wrapper :deep(.ant-pagination-next:hover .anticon) {
    color: #2a4a7a !important;
}

/* 跳轉按鈕 - 完全橢圓 */
.pagination-wrapper :deep(.ant-pagination-jump-prev),
.pagination-wrapper :deep(.ant-pagination-jump-next) {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(200, 200, 210, 0.4) !important;
    color: white !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 50px !important;
    margin: 0 4px !important;
    min-width: 32px !important;
    height: 32px !important;
    line-height: 30px !important;
    transition: all 0.3s ease !important;
}

.pagination-wrapper :deep(.ant-pagination-jump-prev:hover),
.pagination-wrapper :deep(.ant-pagination-jump-next:hover) {
    background: rgba(255, 255, 255, 0.9) !important;
    border-color: rgba(200, 200, 210, 0.4) !important;
    color: white !important;
    box-shadow: none !important;
}

.pagination-wrapper :deep(.ant-pagination-jump-prev .anticon),
.pagination-wrapper :deep(.ant-pagination-jump-next .anticon) {
    color: white !important;
    transition: color 0.3s ease !important;
}

.pagination-wrapper :deep(.ant-pagination-jump-prev:hover .anticon),
.pagination-wrapper :deep(.ant-pagination-jump-next:hover .anticon) {
    color: #2a4a7a !important;
}

/* 總數文字 */
.pagination-wrapper :deep(.ant-pagination-total-text) {
    color: #2a2a3a !important;
    font-family: 'Courier New', monospace !important;
    font-size: 14px !important;
    margin-right: 16px !important;
    height: 32px !important;
    line-height: 32px !important;
    display: inline-flex !important;
    align-items: center !important;
    white-space: nowrap !important;
    flex-shrink: 0 !important;
}

/* 確保分頁組件在同一行 */
.pagination-wrapper :deep(.ant-pagination) {
    display: flex !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    justify-content: center !important;
}

.pagination-wrapper :deep(.ant-pagination .ant-pagination-total-text) {
    flex-shrink: 0 !important;
    white-space: nowrap !important;
}

/* 頁面大小選擇器 */
.pagination-wrapper :deep(.ant-pagination-options) {
    color: white !important;
    margin-left: 16px !important;
}

.pagination-wrapper :deep(.ant-pagination-options-size-changer) {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(200, 200, 210, 0.4) !important;
    color: white !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 50px !important;
    height: 32px !important;
    line-height: 30px !important;
    transition: all 0.3s ease !important;
}

.pagination-wrapper :deep(.ant-pagination-options-size-changer:hover) {
    background: rgba(255, 255, 255, 0.9) !important;
    border-color: rgba(200, 200, 210, 0.4) !important;
    color: white !important;
    box-shadow: none !important;
}

.pagination-wrapper
    :deep(.ant-pagination-options-size-changer .ant-select-selector) {
    background: transparent !important;
    border: none !important;
    color: white !important;
    font-family: 'Courier New', monospace !important;
    height: 30px !important;
    line-height: 30px !important;
}

.pagination-wrapper
    :deep(.ant-pagination-options-size-changer .ant-select-selection-item) {
    color: #1a1a2a !important;
    font-family: 'Courier New', monospace !important;
    line-height: 30px !important;
}

.pagination-wrapper
    :deep(.ant-pagination-options-size-changer .ant-select-arrow) {
    color: #1a1a2a !important;
}

.pagination-wrapper
    :deep(.ant-pagination-options-size-changer:hover .ant-select-arrow) {
    color: #2a4a7a !important;
}

/* 頁面大小選擇器下拉選單 */
.pagination-wrapper :deep(.ant-select-dropdown) {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(200, 200, 210, 0.4) !important;
    border-radius: 16px !important;
    box-shadow: 0 0 20px rgba(42, 74, 122, 0.3) !important;
    min-width: 120px !important;
    width: auto !important;
}

.pagination-wrapper :deep(.ant-select-item) {
    background: transparent !important;
    color: #1a1a2a !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 12px !important;
    margin: 2px 4px !important;
    padding: 8px 12px !important;
    transition: all 0.2s ease !important;
}

.pagination-wrapper :deep(.ant-select-item-option) {
    background: transparent !important;
    color: #1a1a2a !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 12px !important;
    margin: 2px 4px !important;
    padding: 8px 12px !important;
    transition: all 0.2s ease !important;
}

.pagination-wrapper :deep(.ant-select-item:hover) {
    background: rgba(168, 255, 246, 0.2) !important;
    color: #1a1a2a !important;
}

.pagination-wrapper :deep(.ant-select-item-option-selected) {
    background: rgba(42, 74, 122, 0.4) !important;
    color: #1a1a2a !important;
}

.pagination-wrapper :deep(.ant-select-item-option-active) {
    background: rgba(168, 255, 246, 0.2) !important;
    color: #1a1a2a !important;
}

/* 快速跳轉 */
.pagination-wrapper :deep(.ant-pagination-options-quick-jumper) {
    color: #1a1a2a !important;
    font-family: 'Courier New', monospace !important;
    margin-left: 16px !important;
}

.pagination-wrapper :deep(.ant-pagination-options-quick-jumper input) {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid rgba(168, 255, 246, 0.3) !important;
    color: #1a1a2a !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 50px !important;
    height: 32px !important;
    line-height: 30px !important;
    transition: all 0.3s ease !important;
}

.pagination-wrapper :deep(.ant-pagination-options-quick-jumper input:hover) {
    background: rgba(255, 255, 255, 0.9) !important;
    border-color: rgba(168, 255, 246, 0.3) !important;
    color: #1a1a2a !important;
    box-shadow: none !important;
}

.pagination-wrapper :deep(.ant-pagination-options-quick-jumper input:focus) {
    background: rgba(255, 255, 255, 0.9) !important;
    border-color: rgba(168, 255, 246, 0.3) !important;
    color: #1a1a2a !important;
    box-shadow: none !important;
}

/* 響應式設計 */
@media (max-width: 1200px) {
    .filters-row {
        gap: 12px;
    }

    .filter-select {
        width: 120px;
    }

    .price-input {
        width: 90px;
    }
}

@media (max-width: 768px) {
    .search-section {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .search-wrapper {
        max-width: 100%;
    }

    .filter-actions {
        justify-content: stretch;
        width: 100%;
    }

    .filter-actions .function-btn {
        flex: 1;
    }

    .filter-tags-row {
        flex-direction: column;
        gap: 8px;
    }

    .filter-tags-section {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        min-width: 100%;
    }

    .filter-tags {
        width: 100%;
    }

    .products-grid {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 12px;
    }
}

@media (max-width: 480px) {
    .products-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .product-card-image {
        height: 150px;
        min-height: 150px;
    }
}

/* 商品表單 Modal 樣式 */
.product-modal :deep(.ant-modal-content) {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.98),
        rgba(248, 249, 250, 0.95)
    );
    border: 2px solid transparent;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(42, 74, 122, 0.2);
    font-family: 'Courier New', monospace;
    overflow: hidden;
}

.product-modal :deep(.ant-modal-content)::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    padding: 2px;
    background: linear-gradient(45deg, #64748b, #2a4a7a, #3b6ea5);
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: xor;
    opacity: 0.4;
    pointer-events: none;
}

.product-modal :deep(.ant-modal-header) {
    background: transparent;
    border-bottom: 1px solid rgba(42, 74, 122, 0.2);
    padding: 20px 24px;
}

.product-modal :deep(.ant-modal-title) {
    font-family: 'Courier New', monospace;
    font-weight: 700;
    font-size: 20px;
    color: #2a2a3a;
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.product-modal :deep(.ant-modal-body) {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;
}

.product-modal :deep(.ant-modal-footer) {
    border-top: 1px solid rgba(42, 74, 122, 0.2);
    padding: 16px 24px;
    background: rgba(255, 255, 255, 0.5);
}

.product-modal :deep(.ant-btn-primary) {
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5) !important;
    border: none !important;
    color: #ffffff !important;
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.3) !important;
    transition: all 0.2s ease !important;
}

.product-modal :deep(.ant-btn-primary:hover) {
    background: linear-gradient(135deg, #3b6ea5, #2a4a7a) !important;
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.4) !important;
    transform: translateY(-1px) !important;
}

.product-modal :deep(.ant-btn-default) {
    background: #ffffff !important;
    border: 1.5px solid rgba(138, 175, 255, 0.3) !important;
    color: #2a2a3a !important;
    font-family: 'Courier New', monospace !important;
    border-radius: 8px !important;
    transition: all 0.2s ease !important;
}

.product-modal :deep(.ant-btn-default:hover) {
    border-color: rgba(42, 74, 122, 0.5) !important;
    color: #2a4a7a !important;
}

/* 表單樣式 */
.product-form {
    font-family: 'Courier New', monospace;
}

.form-section {
    margin-bottom: 28px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.4);
    border: 1px solid rgba(42, 74, 122, 0.15);
    border-radius: 12px;
    transition: all 0.3s ease;
}

.form-section:hover {
    background: rgba(255, 255, 255, 0.5);
    border-color: rgba(42, 74, 122, 0.25);
}

/* 商品表單 Tab */
.product-form-tabs :deep(.ant-tabs-nav) {
    margin-bottom: 16px;
}

.product-form-tabs :deep(.ant-tabs-tab) {
    font-family: 'Courier New', monospace;
    font-weight: 600;
}

.product-form-tabs :deep(.ant-tabs-tab-active .tab-label-wrap) {
    color: #2a4a7a;
}

.tab-label-wrap {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.tab-error-badge {
    flex-shrink: 0;
}

.tab-pane-content {
    max-height: 60vh;
    overflow-y: auto;
}

.form-section-title {
    font-size: 15px;
    font-weight: 700;
    color: #2a2a3a;
    margin-bottom: 18px;
    padding: 0;
    border: none;
    font-family: 'Courier New', monospace;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 0;
}

.form-item-full {
    width: 100%;
}

.form-item-half {
    flex: 1;
    min-width: 0;
}

.form-item-third {
    flex: 1;
    min-width: 0;
}

.product-form :deep(.ant-form-item-label > label) {
    font-family: 'Courier New', monospace;
    font-weight: 600;
    color: #2a2a3a;
    font-size: 14px;
}

.product-form :deep(.ant-input),
.product-form :deep(.ant-input-number),
.product-form :deep(.ant-select-selector),
.product-form :deep(.ant-picker) {
    border-radius: 8px;
    border-color: rgba(138, 175, 255, 0.3);
    transition: all 0.2s ease;
    font-family: 'Courier New', monospace;
}

.product-form :deep(.ant-input:hover),
.product-form :deep(.ant-input-number:hover),
.product-form :deep(.ant-select-selector:hover),
.product-form :deep(.ant-picker:hover) {
    border-color: rgba(42, 74, 122, 0.5);
}

.product-form :deep(.ant-input:focus),
.product-form :deep(.ant-input-focused),
.product-form :deep(.ant-input-number-focused),
.product-form :deep(.ant-select-focused .ant-select-selector),
.product-form :deep(.ant-picker-focused) {
    border-color: #3b6ea5;
    box-shadow: 0 0 0 2px rgba(138, 175, 255, 0.1);
}

.product-form :deep(.ant-textarea) {
    border-radius: 8px;
    border-color: rgba(138, 175, 255, 0.3);
    font-family: 'Courier New', monospace;
}

.product-form :deep(.ant-textarea:hover) {
    border-color: rgba(42, 74, 122, 0.5);
}

.product-form :deep(.ant-textarea:focus) {
    border-color: #3b6ea5;
    box-shadow: 0 0 0 2px rgba(138, 175, 255, 0.1);
}

/* Radio Group 樣式 */
.form-radio-group {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

.product-form :deep(.ant-radio-wrapper) {
    font-family: 'Courier New', monospace;
    color: #2a2a3a;
    transition: all 0.2s ease;
}

.product-form :deep(.ant-radio-wrapper:hover) {
    color: #2a4a7a;
}

.product-form :deep(.ant-radio-checked .ant-radio-inner) {
    border-color: #2a4a7a;
    background-color: #2a4a7a;
}

.product-form :deep(.ant-radio-inner::after) {
    background-color: #ffffff;
}

/* 稀有度下拉：色塊 + 文字 */
.rarity-option-inline {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.rarity-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.product-form
    .rarity-select
    :deep(.ant-select-selection-item)
    .rarity-option-inline {
    display: inline-flex;
}

/* 規則區域樣式 */
.rules-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.rule-item {
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 10px;
    padding: 18px;
    transition: all 0.2s ease;
}

.rule-item:hover {
    border-color: rgba(42, 74, 122, 0.35);
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1);
    background: rgba(255, 255, 255, 0.8);
}

.rule-item :deep(.ant-row) {
    margin: 0;
}

.rule-item :deep(.ant-col) {
    padding: 0 8px;
}

.rule-item :deep(.ant-select),
.rule-item :deep(.ant-input) {
    width: 100%;
}

/* 點數抵扣樣式 */
.discount-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.discount-empty-state {
    display: flex;
    justify-content: center;
    padding: 20px 0;
}

.add-discount-btn {
    border-color: rgba(42, 74, 122, 0.3) !important;
    color: #2a4a7a !important;
    font-family: 'Courier New', monospace !important;
    transition: all 0.3s ease !important;
}

.add-discount-btn:hover {
    border-color: rgba(42, 74, 122, 0.5) !important;
    background: rgba(42, 74, 122, 0.1) !important;
    color: #3b6ea5 !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.2) !important;
}

.discount-card {
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 12px;
    padding: 20px;
    transition: all 0.2s ease;
}

.discount-card:hover {
    border-color: rgba(42, 74, 122, 0.35);
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1);
    background: rgba(255, 255, 255, 0.8);
}

.discount-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(42, 74, 122, 0.15);
}

.discount-card-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5);
    color: #ffffff;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    font-family: 'Courier New', monospace;
}

.discount-card-actions {
    display: flex;
    gap: 8px;
}

.discount-add-btn {
    color: #3b6ea5 !important;
    font-family: 'Courier New', monospace !important;
    font-size: 12px !important;
    padding: 0 8px !important;
    height: 28px !important;
    display: flex;
    align-items: center;
    gap: 4px;
}

.discount-add-btn:hover {
    background: rgba(138, 175, 255, 0.1) !important;
    color: #2a4a7a !important;
}

.discount-remove-btn {
    color: #ff6b6b !important;
    font-family: 'Courier New', monospace !important;
    font-size: 12px !important;
    padding: 0 8px !important;
    height: 28px !important;
    display: flex;
    align-items: center;
    gap: 4px;
}

.discount-remove-btn:hover {
    background: rgba(255, 107, 107, 0.1) !important;
    color: #ff4d4f !important;
}

.discount-card-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.discount-form-item {
    margin-bottom: 0 !important;
}

.discount-form-item :deep(.ant-form-item-label) {
    padding-bottom: 4px;
}

/* 商品支付方式樣式（緊湊表格式） */
.payment-methods-compact {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.payment-methods-empty {
    padding: 8px 0;
}

.payment-methods-table-wrap {
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.5);
}

.payment-methods-table-header {
    display: grid;
    grid-template-columns: 1fr 110px 100px 130px 48px;
    gap: 8px;
    padding: 6px 10px;
    background: rgba(42, 74, 122, 0.08);
    border-bottom: 1px solid rgba(42, 74, 122, 0.15);
    font-size: 12px;
    font-weight: 600;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    align-items: center;
}

.payment-methods-table-row {
    display: grid;
    grid-template-columns: 1fr 110px 100px 130px 48px;
    gap: 8px;
    padding: 4px 10px;
    align-items: center;
    border-bottom: 1px solid rgba(42, 74, 122, 0.08);
}

.payment-methods-table-row:last-child {
    border-bottom: none;
}

.payment-methods-compact .input-full {
    width: 100%;
}

.payment-methods-compact .input-full :deep(.ant-select),
.payment-methods-compact .input-full :deep(.ant-input),
.payment-methods-compact .input-full :deep(.ant-input-number) {
    width: 100%;
}

/* 總額欄位下方：每期試算提示 */
.per-installment-hint {
    display: block;
    margin-top: 2px;
    font-size: 10px;
    color: #3b6ea5;
    font-family: 'Courier New', monospace;
}

.installment-once {
    font-size: 12px;
    color: #6a6a7a;
    font-family: 'Courier New', monospace;
}

.add-payment-method-link {
    padding-left: 0;
    color: #2a4a7a !important;
    font-family: 'Courier New', monospace !important;
}

.add-payment-method-link:hover {
    color: #3b6ea5 !important;
}

/* 規則／點數緊湊表共用 */
.compact-empty {
    padding: 8px 0;
}

.compact-table-wrap {
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.5);
}

.add-compact-link {
    padding-left: 0;
    margin-top: 6px;
    display: inline-block;
    color: #2a4a7a !important;
    font-family: 'Courier New', monospace !important;
}

.add-compact-link:hover {
    color: #3b6ea5 !important;
}

/* 可見性／可購買性規則表 */
.rules-table-header {
    display: grid;
    grid-template-columns: 120px 1fr 48px;
    gap: 8px;
    padding: 6px 10px;
    background: rgba(42, 74, 122, 0.08);
    border-bottom: 1px solid rgba(42, 74, 122, 0.15);
    font-size: 12px;
    font-weight: 600;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    align-items: center;
}

.rules-table-row {
    display: grid;
    grid-template-columns: 120px 1fr 48px;
    gap: 8px;
    padding: 4px 10px;
    align-items: center;
    border-bottom: 1px solid rgba(42, 74, 122, 0.08);
}

.rules-table-row:last-child {
    border-bottom: none;
}

.rules-compact .input-full,
.discount-compact .input-full {
    width: 100%;
}

.rules-compact .input-full :deep(.ant-select),
.discount-compact .input-full :deep(.ant-select),
.discount-compact .input-full :deep(.ant-input-number) {
    width: 100%;
}

/* 點數抵扣緊湊表 */
.discount-table-header {
    display: grid;
    grid-template-columns: 1fr 100px 100px 48px;
    gap: 8px;
    padding: 6px 10px;
    background: rgba(42, 74, 122, 0.08);
    border-bottom: 1px solid rgba(42, 74, 122, 0.15);
    font-size: 12px;
    font-weight: 600;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    align-items: center;
}

.discount-table-row {
    display: grid;
    grid-template-columns: 1fr 100px 100px 48px;
    gap: 8px;
    padding: 4px 10px;
    align-items: center;
    border-bottom: 1px solid rgba(42, 74, 122, 0.08);
}

.discount-table-row:last-child {
    border-bottom: none;
}

.discount-form-item :deep(.ant-form-item-label > label) {
    font-size: 12px;
    color: #6a6a7a;
    font-weight: 600;
    font-family: 'Courier New', monospace;
}

/* 規則區域按鈕樣式 */
.add-rule-btn {
    margin-top: 8px !important;
    border-color: rgba(42, 74, 122, 0.3) !important;
    color: #2a4a7a !important;
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    height: 44px !important;
    border-radius: 8px !important;
    transition: all 0.2s ease !important;
}

.add-rule-btn:hover {
    border-color: rgba(42, 74, 122, 0.5) !important;
    background: rgba(42, 74, 122, 0.1) !important;
    color: #3b6ea5 !important;
    transform: translateY(-1px);
}

.rule-delete-btn {
    color: #ff6b6b !important;
    transition: all 0.2s ease !important;
}

.rule-delete-btn:hover {
    color: #ff4d4f !important;
    background: rgba(255, 107, 107, 0.1) !important;
}

/* 圖片上傳區域 */
.image-upload-area {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* 上傳注意事項 */
.image-upload-tips {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 14px;
    background: rgba(42, 74, 122, 0.06);
    border: 1px solid rgba(42, 74, 122, 0.15);
    border-radius: 6px;
    margin-bottom: 12px;
}

.tip-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #6a6a7a;
    font-family: 'Courier New', monospace;
}

.tip-icon {
    font-size: 14px;
    flex-shrink: 0;
}

.tip-text {
    line-height: 1.5;
}

.tip-text strong {
    color: #2a4a7a;
    font-weight: 600;
}

.image-preview {
    position: relative;
    width: 100%;
    max-width: 300px;
    border-radius: 8px;
    overflow: visible;
    border: 1px solid rgba(42, 74, 122, 0.2);
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1);
    margin-bottom: 12px;
}

.preview-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    border-radius: 10px;
    pointer-events: none;
}

.remove-image-btn {
    position: absolute;
    top: -12px;
    right: -12px;
    background: rgba(255, 255, 255, 0.95) !important;
    border: 2px solid rgba(255, 77, 79, 0.5) !important;
    border-radius: 50% !important;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease;
    z-index: 10;
    cursor: pointer;
}

.remove-image-btn:hover {
    background: #ff4d4f !important;
    border-color: #ff4d4f !important;
    color: #ffffff !important;
    transform: scale(1.15);
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.4);
}

.upload-btn {
    width: 100%;
    max-width: 300px;
    border: 1px dashed rgba(42, 74, 122, 0.3) !important;
    border-radius: 8px !important;
    background: rgba(255, 255, 255, 0.8) !important;
    color: #2a4a7a !important;
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    transition: all 0.2s ease !important;
    height: 40px !important;
}

.upload-btn:hover {
    border-color: #2a4a7a !important;
    background: rgba(42, 74, 122, 0.1) !important;
    color: #3b6ea5 !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.2);
}

/* 刪除確認內容樣式 */
.delete-confirm-content {
    padding: 20px;
    font-family: 'Courier New', monospace;
    font-size: 16px;
    color: #2a2a3a;
    text-align: center;
    line-height: 1.6;
}

.delete-confirm-content strong {
    color: #2a4a7a;
    font-weight: 700;
}

/* 響應式設計 */
@media (max-width: 768px) {
    .form-row {
        flex-direction: column;
    }

    .form-item-half,
    .form-item-third {
        width: 100%;
    }

    .discount-card-content {
        grid-template-columns: 1fr;
    }
}

/* 商品詳情視窗樣式（蒸氣波風格） */
.product-detail-modal :deep(.ant-modal-content) {
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.98) 0%,
        rgba(248, 249, 255, 0.96) 100%
    );
    border: 1px solid transparent;
    border-radius: 16px;
    box-shadow:
        0 8px 32px rgba(42, 74, 122, 0.2),
        0 0 0 1px rgba(255, 158, 207, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.6);
    font-family: 'Courier New', monospace;
    position: relative;
}

.product-detail-modal :deep(.ant-modal-content)::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 16px;
    padding: 1px;
    background: linear-gradient(135deg, #64748b, #2a4a7a, #3b6ea5, #0e7490);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
}

.product-detail-modal :deep(.ant-modal-header) {
    background: linear-gradient(
        90deg,
        rgba(42, 74, 122, 0.06) 0%,
        transparent 100%
    );
    border-bottom: 1px solid rgba(42, 74, 122, 0.2);
    padding: 18px 24px;
}

.product-detail-modal :deep(.ant-modal-title) {
    font-family: 'Courier New', monospace;
    font-weight: 700;
    font-size: 20px;
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-shadow: 0 0 20px rgba(42, 74, 122, 0.3);
}

.product-detail-modal :deep(.ant-modal-body) {
    padding: 24px;
    max-height: 75vh;
    overflow-y: auto;
}

.product-detail-view {
    font-family: 'Courier New', monospace;
}

/* 頂部區塊 */
.detail-top-section {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(42, 74, 122, 0.15);
}

.detail-image-wrapper {
    width: 180px;
    height: 180px;
    flex-shrink: 0;
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(
        135deg,
        rgba(138, 175, 255, 0.12),
        rgba(42, 74, 122, 0.12)
    );
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid rgba(42, 74, 122, 0.25);
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.1);
}

.detail-cover-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.detail-image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(42, 74, 122, 0.35);
    font-size: 40px;
}

.detail-type-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 10;
}

.detail-basic-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.detail-subtitle {
    font-size: 14px;
    color: #6a6a7a;
    font-weight: 400;
    line-height: 1.4;
}

.detail-status-row {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.detail-status-tag {
    font-size: 12px !important;
    font-weight: 600 !important;
    padding: 4px 12px !important;
    border-radius: 12px !important;
}

.detail-status-tag-draft {
    background: rgba(138, 175, 255, 0.15) !important;
    border-color: rgba(138, 175, 255, 0.3) !important;
    color: #3b6ea5 !important;
}

.detail-status-tag-active {
    background: rgba(208, 255, 183, 0.2) !important;
    border-color: rgba(208, 255, 183, 0.35) !important;
    color: #52c41a !important;
}

.detail-status-tag-inactive {
    background: rgba(255, 168, 122, 0.2) !important;
    border-color: rgba(255, 168, 122, 0.35) !important;
    color: #ffa87a !important;
}

.detail-status-tag-scheduled {
    background: rgba(42, 74, 122, 0.15) !important;
    border-color: rgba(42, 74, 122, 0.3) !important;
    color: #2a4a7a !important;
}

.detail-status-tag-expired {
    background: rgba(106, 106, 122, 0.15) !important;
    border-color: rgba(106, 106, 122, 0.3) !important;
    color: #6a6a7a !important;
}

.detail-shipping-tag {
    background: rgba(168, 255, 246, 0.2) !important;
    border-color: rgba(168, 255, 246, 0.35) !important;
    color: #13c2c2 !important;
}

.detail-header-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px 20px;
    margin-top: auto;
}

.detail-price {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-top: 0;
    flex-shrink: 0;
}

.detail-price .price-label {
    font-size: 13px;
    color: #6a6a7a;
    font-weight: 600;
}

.detail-price .price-value {
    font-size: 26px;
    font-weight: 700;
    color: #2a4a7a;
    text-shadow:
        0 0 12px rgba(42, 74, 122, 0.4),
        0 0 24px rgba(42, 74, 122, 0.2);
    letter-spacing: 0.02em;
}

/* 區塊標題 */
.detail-section-title {
    font-size: 13px;
    font-weight: 700;
    color: #2a2a3a;
    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 2px solid transparent;
    border-image: linear-gradient(90deg, #2a4a7a, #3b6ea5) 1;
    letter-spacing: 0.05em;
}

/* 詳細資訊網格（兩欄） */
.detail-info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 24px;
    margin-bottom: 20px;
}

.detail-info-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid rgba(42, 74, 122, 0.08);
}

.detail-info-item:last-child {
    border-bottom: none;
}

.info-label {
    font-size: 13px;
    color: #6a6a7a;
    font-weight: 600;
    min-width: 88px;
    flex-shrink: 0;
}

.info-value {
    font-size: 14px;
    color: #2a2a3a;
    font-weight: 500;
    flex: 1;
}

.info-value-mono {
    font-size: 13px;
    color: #5a5a6a;
}

.stock-value {
    font-size: 18px;
    font-weight: 700;
    color: #2a4a7a;
    text-shadow: 0 0 8px rgba(42, 74, 122, 0.25);
}

/* 區塊（支付方式、點數、描述） */
.detail-block {
    margin-bottom: 20px;
}

.detail-block .detail-section-title {
    margin-bottom: 10px;
}

/* 支付方式標籤 */
.detail-payment-methods {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.detail-payment-tag {
    background: linear-gradient(
        135deg,
        rgba(42, 74, 122, 0.12),
        rgba(138, 175, 255, 0.12)
    ) !important;
    border: 1px solid rgba(42, 74, 122, 0.25) !important;
    color: #5a3a8a !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    padding: 4px 12px !important;
    border-radius: 8px !important;
}

/* 商品描述 */
.detail-block .description-text {
    line-height: 1.65;
    color: #2a2a3a;
    white-space: pre-wrap;
    word-break: break-word;
    padding: 12px 14px;
    background: rgba(42, 74, 122, 0.04);
    border-radius: 8px;
    border: 1px solid rgba(42, 74, 122, 0.1);
    font-size: 14px;
}

/* 發放物品列表 */
.detail-items-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.detail-item-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    background: linear-gradient(
        90deg,
        rgba(42, 74, 122, 0.06),
        rgba(138, 175, 255, 0.06)
    );
    border-radius: 8px;
    border: 1px solid rgba(42, 74, 122, 0.18);
}

.detail-item-thumb-wrap {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
}

.detail-item-thumb {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid rgba(42, 74, 122, 0.3);
}

.detail-item-thumb-placeholder {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(42, 74, 122, 0.08);
    border-radius: 6px;
    border: 1px solid rgba(42, 74, 122, 0.2);
    color: #2a4a7a;
    font-size: 18px;
}

.detail-item-info {
    flex: 1;
    min-width: 0;
}

.detail-item-name {
    font-size: 14px;
    font-weight: 600;
    color: #2a2a3a;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.detail-item-tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
}

.detail-item-bind {
    font-size: 11px;
    color: #8a8a9a;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 0 6px;
    line-height: 20px;
}

.detail-item-qty {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 2px;
    align-self: center;
    margin-left: auto;
}

.detail-item-qty-label {
    font-size: 11px;
    color: #8a8a9a;
}

.detail-item-qty-value {
    font-size: 18px;
    font-weight: 700;
    color: #2a4a7a;
    font-family: 'Courier New', monospace;
    text-shadow: 0 0 8px rgba(42, 74, 122, 0.2);
}

/* 點數抵扣列表 */
.point-discounts-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.point-discount-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: linear-gradient(
        90deg,
        rgba(42, 74, 122, 0.06),
        rgba(138, 175, 255, 0.06)
    );
    border-radius: 8px;
    border: 1px solid rgba(42, 74, 122, 0.18);
}

.discount-type {
    font-size: 13px;
    font-weight: 600;
    color: #2a2a3a;
    flex: 1;
}

.discount-value {
    font-size: 16px;
    font-weight: 700;
    color: #2a4a7a;
    text-shadow: 0 0 8px rgba(42, 74, 122, 0.2);
}

/* 響應式設計 */
@media (max-width: 768px) {
    .detail-top-section {
        flex-direction: column;
    }

    .detail-image-wrapper {
        width: 100%;
        height: 200px;
    }

    .detail-info-grid {
        grid-template-columns: 1fr;
    }

    .detail-info-item {
        flex-direction: row;
    }

    .info-label {
        min-width: 90px;
    }
}

/* 發放物品清單 */
.product-items-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
}

.product-item-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background: rgba(138, 43, 226, 0.06);
    border: 1px solid rgba(138, 43, 226, 0.2);
    border-radius: 8px;
}

.product-item-thumb-wrap {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
}

.product-item-thumb {
    width: 44px;
    height: 44px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid rgba(138, 43, 226, 0.25);
    display: block;
}

.product-item-thumb-placeholder {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(138, 43, 226, 0.08);
    border-radius: 6px;
    border: 1px solid rgba(138, 43, 226, 0.2);
    color: #2a4a7a;
    font-size: 18px;
}

.product-item-body {
    flex: 1;
    min-width: 0;
}

.product-item-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}

.item-type-tag {
    flex-shrink: 0;
    font-family: 'Courier New', monospace;
    font-size: 11px;
    margin: 0;
}

.product-item-name {
    font-size: 13px;
    color: #4c1d95;
    font-family: 'Courier New', monospace;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.product-item-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
}

.product-item-qty {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.product-item-qty-input {
    width: 72px !important;
}

.qty-label {
    font-size: 12px;
    color: #6b21a8;
    font-family: 'Courier New', monospace;
    white-space: nowrap;
}

.product-items-empty {
    text-align: center;
    color: rgba(107, 33, 168, 0.55);
    font-size: 13px;
    padding: 16px 0;
    font-family: 'Courier New', monospace;
    border: 1px dashed rgba(138, 43, 226, 0.35);
    border-radius: 6px;
    margin-bottom: 12px;
}

.product-item-add-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.form-section-hint {
    font-size: 12px;
    color: #2a4a7a;
    font-family: 'Courier New', monospace;
    margin-bottom: 10px;
}

.extra-consent-collapse {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
    background: transparent;
}

.extra-consent-collapse :deep(.ant-collapse-item) {
    border: 1px solid #e4e6ec !important;
    border-radius: 10px !important;
    overflow: hidden;
    background: #fafafa;
}

.extra-consent-collapse :deep(.ant-collapse-item-active) {
    background: #fff;
    border-color: #d3adf7 !important;
}

.extra-consent-collapse :deep(.ant-collapse-header) {
    align-items: center !important;
    padding: 12px 14px !important;
}

.extra-consent-collapse :deep(.ant-collapse-content-box) {
    padding: 0 14px 14px !important;
}

.extra-consent-collapse__header {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.extra-consent-collapse__idx {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: rgba(114, 46, 209, 0.1);
    color: #722ed1;
    font-size: 12px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.extra-consent-collapse__title {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
    color: #2a2a3a;
}

.extra-consent-collapse__tag {
    flex-shrink: 0;
    margin: 0 !important;
}

.extra-consent-field {
    margin-bottom: 0;
}
</style>

<!-- 期數下拉選單為 portal 渲染，需全域樣式確保選項完整顯示 -->
<style>
.installment-select-dropdown.ant-select-dropdown {
    min-width: 120px;
}

.installment-select-dropdown .ant-select-item-option-content {
    white-space: nowrap;
    overflow: visible;
    text-overflow: unset;
}

.purchase-journey-card {
    margin: 0 0 16px;
    padding: 12px 14px;
    border-radius: 10px;
    background: #f7f8fc;
    border: 1px solid #ebe7f5;
}
.purchase-journey-card__title {
    font-size: 13px;
    font-weight: 700;
    color: #3a3a4a;
    margin-bottom: 8px;
}
.purchase-journey-card__steps {
    margin: 0;
    padding-left: 1.2em;
    font-size: 13px;
    line-height: 1.7;
    color: #595959;
}
.purchase-journey-card__links {
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}
</style>
